const translationsEn = {
    "status": "success",
    "data": {
        "lang": "fr_FR",
        "app": "hotel",
        "translation": {
            "liveBooking": {
  bookingMovedToOperationsMessage:
    'Votre réservation a été traitée avec succès et transférée à notre équipe des opérations pour approbation du fournisseur.',
  pleaseWaitSupplierApproval:
    'Veuillez patienter pendant que le fournisseur examine et confirme votre réservation. Cela prend généralement quelques heures.',
  waitingSupplierApproval: 'EN ATTENTE DE L’APPROBATION DU FOURNISSEUR',
  youWillBeNotified:
    'Vous serez informé par e-mail dès que le fournisseur répondra.',
                                "processingYourBooking": "Traitement de votre réservation...",
                "stepCompletedSuccessfully": "Étape complétée avec succès",
                "somethingWentWrongOurTeamIsWorkingOnIt": "Une erreur s'est produite. Notre équipe travaille dessus.",
                "stepCouldNotBeCompleted": "L'étape n'a pas pu être complétée.",
                "stillProcessingPleaseWait": "Traitement en cours, veuillez patienter...",
                "waitingForSupplierApproval": "En attente de l'approbation du fournisseur",
                "stepAlreadyCompleted": "Étape déjà complétée.",
                "REVALIDATE": "Revalider",
                "RESERVATION": "Réservation",
                "SUMMARY": "Résumé",
                "PAYMENT_FINALIZATION": "Finalisation du paiement",
                "bookingProcessStatus": "Statut du processus de réservation",
                "order": "Commande",
                "lastUpdate": "Dernière mise à jour",
                "liveStreamingNotAvailable": "La diffusion en direct n’est pas disponible — utilisation du sondage de secours. Si le problème persiste, notre équipe des opérations est en train d’examiner la situation.",
                "noProgressAvailable": "Aucune progression de réservation disponible pour le moment.",
                "paymentNotRequired": "Le paiement n’est pas requis pour cette réservation (option Payer plus tard sélectionnée)",
                "paymentProcessed": "Paiement traité",
                "transactionId": "ID de transaction :",
                "processingOrderLevelJob": "Traitement de la tâche au niveau de la commande",
                "emailSentToCustomer": "E-mail envoyé au client",
                "status": "STATUT",
                "retries": "NOUVELLES TENTATIVES",
                "eta": "HEURE ESTIMÉE",
                "timestamp": "HORODATAGE",
                "processing": "En cours de traitement",
                "currentAttempt": "TENTATIVE ACTUELLE",
                "of": "sur",
                "failedToProcess": "Échec du traitement",
                "supplierApiDidNotRespond": "L’API du fournisseur n’a pas répondu dans le délai autorisé.",
                "attempts": "TENTATIVES",
                "duration": "DURÉE",
                "failedAt": "ÉCHEC À",
                "retryAvailable": "Nouvelle tentative disponible",
                "retryStep": "Relancer l’étape",
                "waitingForRetry": "En attente d’une nouvelle tentative après un problème temporaire.",
                "etaForRetry": "Heure estimée pour la nouvelle tentative :",
                "awaitingPreviousStep": "En attente de la fin de l’étape précédente",
                "paymentWillBeProcessed": "Le paiement sera traité ensuite",
                "emailQueued": "Notification e-mail mise en file d’attente",
                "willBeSentAfterPayment": "Sera envoyé après la confirmation du paiement",
                "processFailedAtStep": "Le processus a échoué à l’étape",
                "processingStep": "Traitement de l’étape",
                "system": "Système",
                "bookingConfirmed": "Réservation confirmée !",
                "orderApprovedSuccessfully": "Votre commande a été approuvée avec succès.",
                "sentItineraryToEmail": "Nous avons envoyé l’itinéraire à votre adresse e-mail.",
                "orderConfirmed": "Commande confirmée",
                "allSystemsGo": "Tous les systèmes sont opérationnels !",
                "orderNumber": "Numéro de commande",
                "confirmation": "Confirmation",
                "sentToEmail": "Envoyé par e-mail",
                "checkYourInbox": "Vérifiez votre boîte de réception",
                "completeItinerarySent": "Votre itinéraire complet et les détails de la réservation ont été envoyés à votre adresse e-mail enregistrée.",
                "orderBeingProcessed": "Votre commande est actuellement en cours de traitement.",
                "orderWaitingForSupplier": "Votre commande est actuellement en attente de l’approbation du fournisseur.",
                "errorProcessingStep": "Une erreur est survenue lors du traitement de cette étape.",
                "pending": "en attente",
                "awaitingProcessing": "En attente de traitement.",
                "skipped": "ignoré",
                "stepNotRequired": "Cette étape n’était pas requise pour votre réservation.",
                "completed": "terminé",
                "processSteps": "Étapes du processus",
                "stepsCompletedSuccessfully": "étapes terminées avec succès",
                "allDone": "Terminé",
                "failed": "Échec",
                "inProgress": "En cours",
                "loadingStatus": "Chargement du statut",
                "okay": "D’accord",
                "approved": "Approuvé"
                },

            "crud": {
                "updatedSuccessfully": "Mis à jour avec succès",
                "validationFailed": "Échec de la validation",
                "operationError": "Une erreur est survenue",
                "emptyList": "Aucune donnée trouvée",
                "failToLoad": "Erreur lors du chargement",
                "modelNotFound": "Non trouvé"
            },
            "updateCard": {
                "payment_failed_please_update_card": "Payment failed - please update card",
                "open_the_payment_form": "Open the payment form",
            },
            "auth": {
                authTypeWarning: "Veuillez contacter l'équipe des opérations pour activer l'adhésion - le type d'authentification n'est pas défini",
                authTitle: "Authentification avec l'identifiant et le mobile",
                pleaseLogin: "Veuillez vous connecter avec vos identifiants",
                verify: "Vérifier",
                id: "ID",
                idPlaceholder: "Entrez votre ID",
                idPlaceholderError: "Veuillez entrer votre ID",
                idDigits: "L'ID doit comporter 9 chiffres",
                phone: "Téléphone",
                phonePlaceholderError: "Veuillez entrer votre numéro de téléphone",
                phoneDigits: "Le numéro de téléphone doit comporter 9 chiffres",
                phonePlaceholder: "Entrez votre numéro de téléphone",
                send: "Envoyer",
                authModalTitle: "Authentification avec ID et mobile",
                loginLoaeder: "Connexion en cours...",
                loginError: "Échec de la connexion. Veuillez réessayer.",
                otpLoader: "Vérification du code...",
                loginSuccess: "Connecté avec succès",
                otpError: "Échec de la vérification du code. Veuillez réessayer.",
                otpStartOver: "Vous n'avez pas reçu de code ? Recommencez",
                register: "S'inscrire",
                firstName: "Prénom",
                lastName: "Nom de famille",
                email: "E-mail",
                firstNamePlaceholder: "Entrez votre prénom",
                lastNamePlaceholder: "Entrez votre nom de famille",
                emailPlaceholder: "Entrez votre e-mail",
                firstNamePlaceholderError: "Veuillez entrer votre prénom",
                lastNamePlaceholderError: "Veuillez entrer votre nom de famille",
                emailPlaceholderError: "Veuillez entrer votre e-mail",
                emailInvalid: "Veuillez entrer une adresse e-mail valide",
                nameMinLength: "Le nom doit contenir au moins 2 caractères",
                registerButton: "S'inscrire",
                backToLogin: "Retour à la connexion",
                registrationSuccess: "Inscription réussie",
                registrationSuccessMessage: "Votre inscription a réussi",
                registrationError: "L'inscription a échoué. Veuillez réessayer.",
                dontHaveAccount: "Vous n'avez pas de compte ?",
                registerHere: "S'inscrire ici",
                authWithMobile: "Authentification avec mobile",
                registerWithMobile: "S'inscrire avec numéro de mobile",
                loginTitle: "Connectez-vous pour continuer",
                loginDescription: "Pour réserver ou gérer une commande, veuillez vérifier votre numéro de téléphone. Cela prend moins d'une minute.",
                otpInfo: "Nous enverrons un code à usage unique (OTP). Aucun mot de passe requis.",
                whyLogin: "Pourquoi dois-je me connecter ?",
                newHere: "Nouveau ici ?",
                createAccount: "Créer un compte",
                sendCode: "Envoyer le code",
                privacyNotice: "Nous ne partagerons jamais votre numéro. Des frais SMS peuvent s'appliquer.",
                mobileNumber: "Numéro de mobile",
                accountNotFound: "Le compte n'existe pas",
                continueWithRegistration: "Souhaitez-vous continuer avec l'inscription ?",
                continueRegistration: "Continuer avec l'inscription",
                cancel: "Annuler",
                registrationStepIndicator: "ÉTAPE 2 SUR 2 — ENTRER LES DÉTAILS",
                createYourAccount: "Créez votre compte",
                registrationDescription: "Créez un compte pour réserver plus rapidement et suivre vos commandes.",
                mobileHelper: "Nous l'utiliserons pour vous envoyer votre code de vérification.",
                emailHelper: "Optionnel — pour recevoir des bons et des mises à jour.",
                agreeToTerms: "J'accepte les",
                terms: "Conditions",
                and: "et la",
                privacyPolicy: "Politique de confidentialité",
                alreadyHaveAccount: "Vous avez déjà un compte ?",
                logIn: "Se connecter",
                agreeToTermsError: "Veuillez accepter les Conditions & Politique de confidentialité",
                subscribeNewsletter: "S'abonner à notre newsletter",
                newsletterEmailRequired: "Veuillez entrer votre adresse e-mail pour vous abonner à la newsletter",
                updateProfile: "Mettre à jour le profil",
                logout: "Déconnexion",
                updateProfileSuccess: "Profil mis à jour",
                updateProfileSuccessMessage: "Votre profil a été mis à jour avec succès.",
                updateProfileError: "Échec de la mise à jour du profil. Veuillez réessayer.",
                close: "Fermer",
            },

            "upgradePlan": {
                "general": {
                    "upgrade_plan": "Plan de mise à niveau",
                    "upgrade_plan_to_regular": "Mise à niveau vers le plan régulier",
                    "upgrade_plan_to_pro": "Mise à niveau vers le plan PRO",
                  },
                "regular": {
                    "title": "Mettez à niveau maintenant et accédez aux produits Agent 360 !",
                    "benefits_title_text": "Vous êtes actuellement connecté au forfait Agent 360 Light, si vous effectuez une mise à niveau, vous pourrez bénéficier de",
                    "text_1": "Produits en gros Sky 360",
                    "text_2": "Hôtels pour toutes les destinations dans le monde",
                    "text_3": "Vols réguliers et low-cost",
                    "text_4": "Attractions dans le monde entier",
                    "button_text": "Mettez à niveau maintenant vers Agent 360 !"
                },
                "pro": {
                    "title": "Mettez à niveau maintenant et obtenez un site web pour votre entreprise avec un branding complet !",
                    "benefits_title_text": "Dans le forfait SKY 360 Pro, vous pouvez profiter de",
                    "text_1": "Un site web avec votre domaine unique",
                    "text_2": "Branding d'entreprise - logo et couleurs du site",
                    "text_3": "Promotion de forfaits et de vols sur le site par destinations",
                    "text_4": "Toutes les réservations effectuées appartiendront à votre agence !",
                    "button_text": "Mettez à niveau maintenant vers Pro !"
                }
            },
            "attractionQuestions": {
                "customerInfo": "Customer Info",
                "participantsInfo": "Participants Info",

                "first_name": "First Name",
                "last_name": "Last Name",
                "email_address": "Email Address",
                "phone_number": "Phone Number",
                "pickup_location": "Pickup Location",
                "height_in_centimeters": "Height in Centimeters",
                "weight_in_kilograms": "Weight in Kilograms",
            },
            "contactUs": {
                "requestForQuotation": "Demande de devis",
                "problemWithExistingOrder": "Problème avec une commande existante",
                "customerService": "Service client",
                "other": "Autre",
                "messageReceivedSuccessfully": "Message reçu avec succès",
                "email": "Email",
                "phone": "Téléphone",
                "fullName": "Nom complet",
                "writeUsMessage": "Écrivez-nous un message",
                "send": "Envoyer",
                "phoneRequired": "Veuillez entrer un numéro de téléphone",
                "emailRequired": "Veuillez entrer une adresse e-mail",
                "fullNameRequired": "Veuillez entrer un nom complet",
                "messageRequired": "Veuillez entrer un message",
                "nameMinLength": "Le nom doit contenir au moins 2 caractères",
                "emailInvalid": "Veuillez entrer une adresse e-mail valide",
                "subjectRequired": "Veuillez sélectionner un sujet",
                "selectSubject": "Sélectionner un sujet",
                "messageMin": "Le message doit contenir au moins 10 caractères",
                "aboutUs": "À propos de nous"
            },
            "cart": {
                "addToCart": "Ajouter au panier",
                "select": "Sélectionner",
                "remove": "Retirer",
            },
            "customerSupport": {
                "customerService": "Service client",
                "sendMessageAndGetNotified": "Envoyez-nous un message et l'enchérisseur vous répondra dès que possible",
                "callUs": "Appelez-nous :"
            },
            "roomInfo": {
                "info": "Description de la chambre",
                "viewAllThePhotos": "Voir toutes les photos",
                "roomSize": "Taille de la chambre (m²)",
                "peopleInTheRoom": "Personnes dans la chambre",
                "doubleBed": "Lit double"
            },
            "conceptsList": {
                "conceptsListTitle": "Titre de la liste des concepts",
                "includesActivities": "Attractions offertes",
                "includesActivity": "Comprend une attraction offerte",
                "includeInPackage": "Inclus dans le forfait",
                "transfer": "Transfert",
                "includesTransfer": "Comprend le transfert",
                "transferContent": "Transferts HOS au prix du forfait",
                "baseBoard": "Formule de base",
                "autoApprove": "Approbation automatique",
                "airways": "Compagnies aériennes",
                "flightFrom": "Vol depuis",
                "flightBack": "Vol retour",
                "nights": "Nuits",
                "numberOf": "Nombre",
                "toOrder": "Commander",
                "noPackagesFound": "Aucun forfait trouvé",
                "moreDeals": "Plus d'offres",
                "pricePerPerson": "Prix par personne"
            },
            "wallet":{
                future: "Bénéfices non réalisés",
                creditCard:"Carte de crédit",
                cancel: "Annuler",
                forConfirmationRedemption: "Êtes-vous sûr de vouloir échanger les diamants ?",
                TotalDiamondsYouWillReceive: "Total de diamants que vous recevrez",
                max: "Max",
                currentOrderTotal: "Total de la commande actuelle",
                MaximumRedeemable: "Montant maximum échangeable :",
                UseMax: "Utiliser le maximum",
                Apply: "Appliquer",
                Applying: "Application en cours...",
                RedeemDiamonds: "Échanger des diamants",
                RemainingDiamonds: "Diamants restants",
                DiscountedValue: "Valeur après réduction",
                RedeemedAmount: "Montant échangé",
                Redeemed: "Échangé",
                totalValue: "Valeur totale",
                diamondsRate: "1 diamant = 1 ILS",
                availableDiamonds: "Diamants disponibles",
                diamondBalance: "Solde de diamants",
                discount: "remise",
                Subtotal: "Sous-total",
                paymentDetails: "Détails du paiement",
                totalPayment: "Paiement total :",
                "wallet": "Portefeuille",
                "walletTransactions": "Transactions du portefeuille",
                "walletBalance": "Solde du portefeuille",
                "diamonds": "diamants",
                "diamondsAreAvailableAtYourDisposal": "diamants sont à votre disposition",
                "paymentWithDiamonds": "Paiement avec des diamants",
                "returnToOrderManagement": "Retour à la gestion des commandes",
                "reserve": "Réserver",
                "finalize": "Finaliser",
                "release": "Libérer",
                "partialRealization": "Réalisation partielle",
                "fullRealization": "Réalisation complète",
                "selectNumberOfDiamondsForPartialUse": "Sélectionnez le nombre de diamants pour une utilisation partielle",
                "useAllTheDiamondsIHave": "Utiliser tous les diamants que j'ai",
                "save": "sauvegarder",
                "confirm": "confirmer",
                "forConfirmation": "pour confirmation",
                "totalAgentFee": "Frais d'agent total",

                "dynamicLabels": {
                    'availableDiamondsForPayment': `Vous avez #{amount} diamants disponibles pour le paiement, d'une valeur de #{price}`,
                    'XOfDiamondsWorthY': `#{amount} diamants, d'une valeur de #{price}`,
                    'totalDiamondsYouHaveAccumulatedOverTheLast12MonthsAsOfToday': `Total des diamants que vous avez accumulés au cours des 12 derniers mois à ce jour`,
                  },
            },
            "viewFlight": {
                "sameRates": "Mêmes tarifs",
                "pleaseSelectDestinationAirport": "Veuillez sélectionner l'aéroport de destination",
                "noNearbyAirportFound": "Aucun aéroport proche n'a été trouvé. Veuillez rechercher un aéroport et vous assurer qu'il est situé près de l'hôtel",
                "chooseAirportYouWantToArrive": "Choisir l'aéroport d'arrivée",
                "chooseAirportYouWantToArriveDescription": "Veuillez choisir un aéroport proche de l'hôtel",
                "updateAirport": "Mettre à jour l'aéroport",
                "noFlightsForSelectedDatesLocationPassengers": "Aucun vol disponible pour les dates/location/passagers sélectionnés",
                "flightFrom": "Vol depuis",
                "flightChange": "Changer de vol",
                "totalChange": "Changement total",
                "noFlightsAvailableForSelectedDates": "Aucun vol disponible pour les dates sélectionnées, veuillez choisir d'autres dates",
                "show_tickets_with_different_fare_combinations": "Afficher les billets avec différentes combinaisons de tarifs",
                "ticketFare": "Tarif",
                "ticketInfo": "Informations sur le billet",
                "termsAndConditions": "Conditions générales",
                "ifTicketIncludeSeat": "Si le billet comprend un siège - le client devra le choisir sur le site de la compagnie aérienne",
                "inCaseOfChange": "En cas de modification - le client devra payer un supplément si le billet mis à jour est plus cher, des frais de service supplémentaires s'appliquent selon les Conditions générales du site",
                "inCaseOfCancellation": "En cas d'annulation - des frais de service supplémentaires s'appliquent selon les Conditions générales du site",
                "error4305Title": "Oups, le vol est complet",
                "error4305Content": "Nous nous excusons, mais il semble que les places pour cette offre soient épuisées, nous ne pouvons pas procéder à l'achat. Vous êtes redirigé vers la page principale.",
                "TC": "CG",
                "flights": "Vols",
                "title": "Vol sélectionné, vérifiez les détails et procédez au paiement",
                "addBaggage": "Ajouter des bagages",
                "closeAddBaggage": "Masquer les options",
                "addTrolly": "Ajouter un chariot",
                "somethingWetWrong": "Quelque chose s'est mal passé",
                "suitcasePrice": "Prix de la valise",
                "trollyPrice": "Prix du chariot",
                "totalPerPassenger": "Total par passager",
                "updatePassengers": "Mettre à jour le nombre de passagers",
                "search": "Rechercher",
                "seating": "Places",
                "cancelation": "Annulation du billet",
                "meal": "Repas",
                "trolly": "Chariot",
                "suitcase": "Valise",
                "changeFlight": "Changer le billet",
                "extension": "Prolongation",
                "totalToBePaid": "Total à payer",
                "choose": "Choisir",
                "checkAmenities": "Vérifier les équipements",
                "description": "Description",
                "amenityType": "Type d'équipement",
                "flightFromAmenities": "Équipements du vol aller",
                "flightBackAmenities": "Équipements du vol retour",
                "BAGGAGE": "Bagages",
                "2 CHECKED BAGS UP TO 32KG EACH": "2 bagages enregistrés jusqu'à 32 kg chacun",
                "2 CABIN BAGS UP TO 8KG": "2 bagages cabine jusqu'à 8 kg",
                "BRANDED_FARES": "Tarifs de marque",
                "STANDARD SEAT RESERVATION": "Réservation de siège standard",
                "MILEAGE_ACCRUAL": "Accumulation de miles",
                "MEAL": "Repas",
                "SNACK": "Collation",
                "COMPLIMENTARY FOOD AND BEV": "Nourriture et boissons offertes",
                "ENTERTAINMENT": "Divertissement",
                "MAGAZINES / NEWSPAPER": "Magazines / Journaux",
                "LOUNGE": "Salon",
                "LOUNGE ACCESS": "Accès au salon",
                "TRAVEL_SERVICES": "Services de voyage",
                "PRIORITY BAGGAGE": "Bagages prioritaires",
                "PRIORITY CHECK IN": "Enregistrement prioritaire",
                "PRIORITY SECURITY": "Sécurité prioritaire",
                "PRIORITY BOARDING": "Embarquement prioritaire",
                "IN FLIGHT ENTERTAINMENT": "Divertissement à bord",
                "PRE_RESERVED_SEAT": "Siège pré-réservé",
                "PRIVACY SEAT BUSINESS CLASS": "Siège privé en classe affaires",
                "CHANGE BEFORE DEPARTURE": "Changement avant le départ",
                "CHANGE AFTER DEPARTURE": "Changement après le départ",
                "REFUND BEFORE DEPARTURE": "Remboursement avant le départ",
                "REFUND AFTER DEPARTURE": "Remboursement après le départ",
                "allFares": "Tous les tarifs",
                "fareChangedSuccessfully": "Tarif modifié avec succès",
                "openFares": "Tarifs ouverts",
                "selectedFare": "Tarif sélectionné",
                "fullInfo": "Informations complètes",
                "MILEAGE ACCRUAL": "Accumulation de miles"
            },
            "room": {
                "roomSize": "Taille de la chambre",
                "bedType": "Type de lit",
                "breakfastIncluded": "Petit-déjeuner inclus",
                "noAvailabilityOnSelectedDates": "Aucune disponibilité pour cette chambre aux dates sélectionnées"
            },
            "promotion": {
                "modelNotFound": "Page non trouvée",
                "failToLoad": "Échec du chargement de la page !"
            },
            "searchDatePicker": {
                "showingAllResultsWithin": "Afficher tous les résultats dans un rayon de",
                'PARTICIPANTS': 'Participants',
                'CITY': 'Ville',
                'COUNTRY': 'Pays',
                'EVENT_TYPE': 'Type d\'événement',
                'TOURNAMENTS': 'Tournois',
                'VENUES': 'Lieux',
                "events":"Événements",
                "sportsAndEvents":"Sports et événements",
                checking: "Vérification",
                providers: "fournisseurs",
                keepScanning: "Garder la recherche",
                validatePricesInRealTime: "Valider les prix en temps réel",
                foundSoFar: "Trouvé jusqu'à présent",
                return: "Retour",
                calendar: "Calendrier",
                cubes: "Cubes",
                requiredFields: "Veuillez remplir tous les champs obligatoires : destination, départ et dates pour afficher les résultats.",
                otherDeparture:"autre départ",
                departure: "Départ",
                "freeCancellationTooltipText": "L'annulation gratuite ne s'applique qu'aux chambres d'hôtel",
                "mapView": "Vue de la carte",
                "dynamicPackages": "Forfaits dynamiques",
                "includeEvents": "Inclure les événements",
                "includeFullPackage": "Inclure le forfait complet",
                "package_hotel_flight": "Forfait (Hôtel + Vol)",
                "package_hotel_flight_events": "Forfait (Hôtel + Vol + Événements)",
                "hotel_plus_flight": "Hôtel + Vol",
                "hotel_plus_flight_events": "Hôtel + Vol + Événements",
                "searchHotelsByNameTitle": "Rechercher par nom d'hôtel pour la destination sélectionnée",
                "choose_packages_according_to": "Choisissez des forfaits en fonction de",
                "tech_stops": "arrêts techniques",
                "freePlanFlightSearchFooterText": "Le plan gratuit permet de rechercher uniquement des vols charter ! Si vous souhaitez des vols GDS",
                "clickHere": "Cliquez ici",
                "approveSelection": "Approuver la sélection",
                "room": "Chambre",
                "addRoom": "Ajouter une chambre",
                "removeRoom": "Supprimer la chambre",
                "needAnotherRoomAddToCart": "Besoin d'une autre chambre ? Ajoutez-la simplement au panier.",
                "indirectFlight": "Vol avec escale",
                "directFlightLabel": "Vol direct",
                "city": "Ville",
                "hotel": "Hôtel",
                "searchForDestination": "Rechercher des destinations",
                "searchByDestinationAndHotel": "Rechercher par destinations et hôtels",
                "searchHotelOrDestination": "Rechercher un hôtel ou une destination",
                "date": "Date",
                "noResultsForThisDate": "Aucun forfait trouvé pour cette date",
                "searchDestination": "Rechercher une destination",
                "pleaseSelectDestination": "Veuillez sélectionner une destination",
                "airlineInformation": "Informations sur la compagnie aérienne",
                "airlineCode": "Code",
                "title": "Réservez vos vacances de rêve",
                "hotelOnly": "Rechercher des vacances par dates",
                "hotelWithFlight": "Rechercher des vacances incluant un vol",
                "oneWay": "Aller simple",
                "roundTrip": "Aller-retour",
                "selectDate": "Sélection des dates",
                "startDate": "Date de début",
                "endDate": "Date de fin",
                "flights": "Rechercher des vols",
                "packages": "Forfaits vacances",
                "hotels": "Hôtels à l'étranger",
                "israelPackage": "Vacances en Israël",
                "specialPackage": "Forfaits spéciaux",
                "passengers": "Passagers",
                "adults": "Adultes",
                "adult": "Adulte",
                "child": "Enfant",
                "children": "Enfants",
                "infant": "Bébé",
                "infants": "Bébés",
                "infantsWarningMessage": "Le bébé doit avoir moins de deux ans à l'aller et au retour",
                "select": "Sélectionner",
                "noResults": "Aucun résultat",
                "checkout": "Réservez maintenant",
                "regularPrice": "Prix régulier",
                "from": "À partir de",
                "purchase": "Acheter",
                "selectNewFlight": "Sélectionnez un nouveau vol",
                "search": "Rechercher",
                "rooms": "Chambres",
                "composition": "Composition",
                "chooseComposition": "Choisissez la composition",
                "numberOfGuests": "Nombre de clients",
                "checkOut": "Départ",
                "checkIn": "Arrivée",
                "whatVacation": "Quel type de vacances",
                "youWant": "voulez-vous",
                "vacationFriendsWith": "Vacances avec des amis",
                "familyVacation": "Vacances en famille",
                "romanticVacation": "Vacances romantiques",
                "notAvailable": "Non disponible",
                "roomAvailableDuringTheWeek": "Disponibilité de la chambre pendant la semaine",
                "followingDates": "Dates suivantes",
                "vacation": "Vacances",
                "abroad": "À l'étranger",
                "inIsrael": "Dans le pays",
                "destination": "Toutes les destinations",
                "chooseDestination": "Choisissez une destination",
                "findDreamVacation": "Trouvez vos vacances parfaites en un clic.",
                "searchResTitle": "Choisissez le forfait qui vous convient",
                "directFlight": "Vol direct",
                "stops": "escales",
                "checkHotel": "Vérifiez l'hôtel",
                "noRating": "Pas de note",
                "toOrder": "Commander",
                "selectAgain": "Sélectionnez à nouveau",
                "selectFlight": "Sélectionnez un vol",
                "reselectFlight": "Resélectionner les vols",
                "flightCanBeReSelectedNextPage": "Le vol peut être ré-sélectionné sur la page suivante",
                "flightSelectedSuccessfully": "Vol sélectionné avec succès",
                "dynamicFlight": "Vol dynamique",
                "bundle": "Vol groupé",
                "freeCancelation": "Annulation gratuite",
                "partially_operated_by_airlines": "Partiellement opéré par des compagnies aériennes",
                "connect_in_airport": "Correspondance à l'aéroport",
                "arrives": "Arrive",
                "journey_duration": "Durée du trajet",
                "short_wait": "Attente courte",
                "long_wait": "Attente longue",
                "flight_number": "Numéro de vol",
                "stop_1": "Une escale",
                "activeFlight": "Vol activé",
                "flightSearch": "Recherche de vol",
                "nights": "Nuits",
                "until": "Jusqu'à la date",
                "untilYouSearchForFlightDate": "Jusqu'à la date de recherche du vol",
                "destinationFrom": "Départ",
                "packageSearch": "Recherche de forfait",
                "destinationTo": "Arrivée",
                "selectDestination": "Destination",
                "trollyIsIncluded": "Chariot inclus",
                "trollyIsNotIncluded": "Chariot non inclus",
                "suitcaseIsIncluded": "Valise incluse",
                "suitcaseIsNotIncluded": "Valise non incluse",
                "operated_by_airlines": "Opéré par",
            },
            "specialDeal": {
                "closeTheDeal": "Conclure l'affaire ›",
                "endsIn": "Se termine dans",
                "specialDealForTheWeekend": "Offre spéciale pour le week-end",
                "from": "À partir de la date",
                "until": "Jusqu'à la date"
            },
            "footer": {
                "backToTop": "Retour en haut",
                "allRightsReserved": "© Tous droits réservés. Ne pas copier le contenu du site sans permission.",
                "developBy": "Développé par SKY 360 Tech.",
                "thePurchaseOnTheWebsiteIsSecure": "L'achat sur le site est sécurisé.",
                "talkToUs": "Comment nous contacter ?",
                "address": "Adresse",
                "phoneAndWhatsapp": "Téléphone ou WhatsApp",
                "phone": "Téléphone",
                "whatsapp": "Whatsapp"
            },
            "sportsAndEvents": {
                "atLeastOneTicketMustBeSelected": "Au moins un billet doit être sélectionné",
                "dateNotFinal": "Date non définitive",
                "timeNotFinal": "Heure non définitive",
                "dateAndTimeNotFinal": "Date et heure non définitive",
                "dateIsSubjectToChange": "Date est sujette à changement",
                "timeIsSubjectToChange": "Heure est sujette à changement",
                "dateAndTimeAreSubjectToChange": "Date et heure sont sujettes à changement",
                "onlyAFewTicketsLeft": "Seules quelques places sont disponibles",
                "pricePerTicket": "Prix par billet",
                "totalPrice": "Prix total",
                "cannotChangeSeatingFromThisPage": "Vous ne pouvez pas changer le siège depuis cette page",
                "reselectSeating": "Résélectionner le siège",
                "sportsAndEvents": "Sports et événements",
                "noTitle": "Événement",
                "comingSoon": "Bientôt!",
                "noTicketsAvailable": "Aucun billet disponible",
                "selectTickets": "Sélectionner les billets",
                "notifyMe": "Me notifier",
                "notifyMeDescription": "Entrez votre adresse e-mail pour être averti lorsque les billets seront disponibles",
                "notifyMeEmailPlaceholder": "Entrez votre adresse e-mail",
                "notifyMeSubmit": "Me notifier",
                "notifyMeSuccess": "Vous serez averti lorsque les billets seront disponibles",
                "notifyMeError": "Échec de l'envoi de la notification. Veuillez réessayer.",
                "notifyMeEmailRequired": "Veuillez entrer votre adresse e-mail",
                "notifyMeEmailInvalid": "Veuillez entrer une adresse e-mail valide",
                "tournament": "Tournoi",
                "participants": "Participants",
                "eventType": "Type d'événement",
                "vipPackage": "Forfait VIP",
                "hold24Hours": "Réservation 24h",
                "instantConfirmation": "Confirmation instantanée",
                "offlineStock": "Stock hors ligne",
                "rating": "Note",
                "location": "Lieu",
                "dateTimeSeparator": " à ",
                "viewOnMap": "Voir sur la carte",
                "selectQuantity": "Sélectionner la quantité",
                "avenue": "Avenue",
                "venue": "Lieu",
                "city": "Ville",
                "country": "Pays",
                "state": "État",
                "zip": "Code postal",
                "latitude": "Latitude",
                "longitude": "Longitude",
                "whereWillISit": "Où vais-je m'asseoir?",
                "seatingArrangements": "Arrangements de places",
                "seatingInPairs": "Places par paires",
                "seatingInPairsDescription": "Nous nous engageons à vous asseoir par paires (deux ensemble) sauf si la catégorie de billet indique le contraire.",
                "seatingInPairsNote": "VEUILLEZ NOTER: dans certains stades (notamment le Camp Nou de Barcelone et le Santiago Bernabéu du Real Madrid), \"places par paires\" comprend des sièges adjacents en diagonale ou perpendiculairement.",
                "seatingThreeTogether": "Places pour trois ou plus",
                "seatingThreeTogetherDescription": "Lorsque vous avez besoin de trois billets ou plus, nous ferons de notre mieux pour vous asseoir ensemble; cependant, nous ne pouvons pas le garantir.",
                "seatingThreeTogetherNote": "Si vous DEVEZ être assis ensemble, veuillez vérifier la disponibilité auprès de notre équipe de service client, par téléphone ou par e-mail. Dans la plupart des cas, nous serons en mesure de confirmer une demande spécifique ou d'offrir une solution alternative.",
                "homeFansOrAwayFans": "Supporters locaux ou visiteurs",
                "homeFansDescription": "Tous les billets sont pour la section des supporters locaux, sauf indication contraire (\"Section des visiteurs\").",
                "homeFansBehaviorCode": "Selon les codes de comportement de l'organisateur, vous n'êtes pas autorisé à encourager l'équipe visiteuse ou à porter les couleurs de l'équipe visiteuse. Il est également conseillé aux participants de porter des vêtements de couleur neutre s'ils ne soutiennent pas l'équipe locale. Le non-respect de ces règles peut être interprété comme une provocation et pourrait vous faire expulser du stade.",
                "neutralVenueNote": "Les spécifications ci-dessus ne s'appliquent pas aux matchs qui se jouent sur un terrain neutre (comme la finale de la Ligue des champions, la finale de la Ligue Europa, la finale de la FA Cup, la finale de la Coupe de la Ligue ou les événements de la Coupe du monde). Sauf indication contraire, les sièges peuvent être situés dans l'une ou l'autre des sections, il est donc conseillé de porter des vêtements de couleur neutre.",
                "singleTickets": "Billets individuels",
                "singleTicketsDescription": "Nous proposons parfois des billets spécifiquement classés comme \"individuels\".",
                "singleTicketsNote": "Ces billets sont généralement moins chers, mais ils sont ce qu'ils sont - individuels. Si vous achetez deux billets \"individuels\", vous ne serez pas assis ensemble.",
                "groupSeating": "Places de groupe",
                "groupSeatingDescription": "Pour 8 billets ou plus, veuillez vérifier la disponibilité pour les places de groupe et le prix auprès de notre équipe de service client, par téléphone ou par e-mail. Les places de groupe peuvent coûter moins ou plus, selon la disponibilité.",
                "groupSeatingNote": "Si la catégorie de billet que vous avez choisie le permet - vous pouvez passer la commande sans nous contacter d'abord, mais veuillez noter que dans ce cas, nous ne pouvons garantir que de vous asseoir par paires.",
                "pleaseNote": "Veuillez noter",
                "pleaseNoteDescription": "Les informations ci-dessus sur les arrangements de places sont génériques et peuvent ne pas correspondre à la description exacte du billet que vous avez choisi. Lorsqu'elles sont disponibles, nous présentons le plan de salle pertinent ou la carte du lieu.",
                "pleaseNoteConsult": "Veuillez le consulter lors de l'examen des catégories de billets pour cet événement.",
                "haveMoreQuestions": "Avez-vous d'autres questions?",
                "contactUsForInfo": "Pour plus d'informations, n'hésitez pas à nous contacter",
                "eventLoadError": "Échec du chargement des détails de l'événement",
                "quantity": "Quantité",
                "deliveryMethod": "Mode de livraison",
                "selectDeliveryMethod": "Sélectionner la livraison",
                "ticketsAvailable": "billets disponibles",
                "available": "Disponible",
                "quantityCannotBeZero": "La quantité ne peut pas être 0",
                "deliveryMethodNotFound": "Mode de livraison introuvable",
            },
            "newsletter": {
                "title": "Abonnez-vous à notre newsletter",
                "subtitle": "Recevez des offres exclusives et de l'inspiration voyage",
                "placeholder": "Entrez votre email",
                "subscribe": "S'abonner",
                "pleaseEnterEmail": "Veuillez entrer votre adresse email",
                "somethingWentWrong": "Une erreur s'est produite. Veuillez réessayer."
            },
            "packages": {
                "tour": "Tour",

                "availableSeats": "Places disponibles",
                "from": "À partir de la date",
                "until": "Jusqu'à la date",
                "breakfastIncluded": "Petit-déjeuner inclus",
                "includesMassageAndSpa": "Inclut massage et spa !",
                "lastRoom": "Dernière chambre !",
                "includesTransfers": "Inclut les transferts",
                "includesActivities": "Inclut des attractions",
                "nights": "Nuits",
                "withoutBaggage": "Sans bagage",
                "directFlight": "Vol direct",
                "oneStop": "Une escale",
                "numOfStops": "Escales",
                "flightDetails": "Détails du vol",
                "flightFrom": " de -> à",
                "flightBack": " de -> à",
                "hours": "Heures",
                "flightNumber": "Numéro de vol",
                "airLine": "Compagnie aérienne",
                "suitcaseWeight": "poidskg Bagage inclus",
                "trollyWeight": "poidskg Chariot inclus",
                "includedActivitiesTitle": "Attractions et visites dans le forfait",
                "checkAllPictures": "Voir toutes les photos",
                "affiliateWith": "En collaboration avec",
                "addButtonDisabledTooltip": "La commande est limitée à la quantité de chambres - impossible d'ajouter une autre chambre. Pour changer de chambre, retirez-en une du panier",
                "holidaySchedule": "Programme des vacances",
                "passengers": "Passagers",
                "isRoundTrip": "Prix des bagages pour un aller-retour *",
                "includesFlights": "Inclut les vols",
                "includesEventTicket": "Inclut un billet d'événement",
                "returnFlight": "Vol retour",
                "outboundFlight": "Vol aller",
                "trollyWeight2": "poids kg chariot / sac",
                "suitcaseWeight2": "poids kg valise",
                "included": "Inclus",
                "notIncluded": "Non inclus",
                "perPax": "Par passager",
                "addSuitcaseLater": "Vous pouvez ajouter plus tard",
                "clickForDetails": "Cliquez ici pour les détails de l'attraction",
                "includedInPackage": "Inclus dans le forfait !"
            },
            "roomPricing": {
                "noRoomsAvailableForSelectedDates": "Aucune chambre disponible pour les dates sélectionnées, veuillez choisir d'autres dates",
                "noRoomsAvailable": "Aucune chambre disponible pour les dates et les invités sélectionnés.",
                "for": "pour",
                "addPassenger": "Ajouter un passager",
                "pricePerPerson": "Prix par personne",
                "pricePerRoom": "Prix par chambre",
                "priceForAllRooms": "Prix pour toutes les chambres",
                "payOnSpot": "Payer sur place",
                "resort_fee": "Frais de séjour",
                "occupancy_tax": "Taxe d'occupation",
                "totalPrice": "Prix total",
                "pricePerInfant": "Prix par bébé",
                "composition": "Composition",
                "adultsInTheRoom": "Adultes",
                "children": "Enfants",
                "adults": "Adultes",
                "single": "Adulte seul",
                "child": "Enfant",
                "selectInfantCount": "Sélectionnez dans la liste",
                "infant": "Bébé",
                "1infant": "Un bébé",
                "2infants": "2 bébés",
                "infants": "Bébés",
                "noInfants": "Sans bébés",
                "all_include": "Tout inclus",
                "breakfast": "Petit-déjeuner",
                "activities": "Choisir une visite",
                "half_board": "Demi-pension",
                "half_board_kosher": "Demi-pension casher",
                "full_board": "Pension complète",
                "sleep_only": "Chambre uniquement",
                "breakfast_kidush": "Repas du matin et du soir du vendredi",
                "addToCard": "Ajouter à la commande",
                "inPackageDates": "Dates du forfait",
                "chooseRoom": "Choisir la composition de la chambre",
                "nights": "Nuits",
                "boardType": "Type de pension",
                "filters": "Filtres",
                "freeCancellation": "Annulation gratuite",
                "roomInfo": "Infos chambre",
                "noAvailableRooms": "Aucune chambre disponible pour les dates sélectionnées",
                "noAvailableRoomsForDates": "Chambre non disponible pour les dates sélectionnées",
                "addInfant": "Ajouter un bébé",
                "roomFacilities": "Équipements de la chambre",
                "show_images": "Voir les images",
                "autoApprove": "Approbation automatique",
                "includedInPrice": "Inclus dans le prix",
                "until": "Jusqu'à",
                "no": "Non",
                "vat": "TVA",
                "is": "Est",
                "not": "Non",
                "city_tax": "Taxe de séjour",
                "cancellation_policy": "Politique d'annulation",
                "your_local_time": "*Votre heure locale",
                "additional_price_info": "Informations de prix supplémentaires",
                "policy": {
                    "freeCancallationUntil": "Annulation gratuite à ce tarif jusqu'à",
                    "freeCancallationUntil2": "Annulation gratuite jusqu'à",
                    "cancallationBeCharged": "Vous serez facturé",
                    "ifYouCancelBetween": "Si vous annulez à partir de",
                    "ifYouCancelModifiedBetween": "Si vous annulez ou modifiez après",
                    "cancelFullPrice": "le prix total de la réservation sera facturé",
                    "till": "jusqu'à",
                    "rateNonRefundable": "Le tarif est non remboursable en cas d'annulation"
                }
            },
            "boards": {
                "RO": "CHAMBRE SEULEMENT",
                "BB": "PETIT-DÉJEUNER INCLUS",
                "HB": "DEMI-PENSION",
                "FB": "PENSION COMPLÈTE",
                "AI": "TOUT INCLUS",
                "UI": "ULTRA TOUT INCLUS DE LUXE",
                "BF": "PETIT-DÉJEUNER BUFFET",
                "KB": "PETIT-DÉJEUNER FROID BUFFET",
                "KBB": "Kosher Breakfast",
                "CB": "PETIT-DÉJEUNER CONTINENTAL",
                "AB": "PETIT-DÉJEUNER AMÉRICAIN",
                "DR": "DÎNER ET CHAMBRE",
                "EB": "PETIT-DÉJEUNER ANGLAIS",
                "FT": "PENSION COMPLÈTE + TRAITEMENTS",
                "F+": "PENSION COMPLÈTE PLUS",
                "GA": "DÎNER GALA",
                "H6": "DEMI-PENSION + 6 TRAITEMENTS UNIQUEMENT",
                "HT": "DEMI-PENSION + TRAITEMENTS",
                "IB": "PETIT-DÉJEUNER ISRAÉLIEN",
                "KO": "CASCHER",
                "KS": "PETIT-DÉJEUNER CASCHER",
                "MI": "MAX TOUT INCLUS",
                "RB": "CHAMBRE & PETIT-DÉJEUNER",
                "NN": "VOIR ITINÉRAIRE",
                "SI": "SOFT TOUT INCLUS",
                "UL": "ULTRA TOUT INCLUS",
                "half_board": "Demi-pension",
                "half_board_kosher": "Demi-pension casher",
                "full_board": "Pension complète",
                "sleep_only": "Chambre uniquement",
                "breakfast_kidush": "Repas du matin et du soir du vendredi",
                "breakfast": "BB",
                "breakfast-for-2": "BB pour 2",
                "nomeal": "Chambre uniquement"
            },
            "activitiesTranslations": {
                "addToOrder": "Ajouter à la commande",
                "passenger": "Pour le passager",
                "showMore": "Afficher plus",
                "addAttractionsAndTrips": "Ajouter des attractions et des excursions",
                "doYouWantToAddAttractions": "Voulez-vous ajouter des attractions à vos vacances ?",
                "itsTime": "Il est temps !",
                "pricePerPerson": "Prix par personne"
            },
            "modal": {
                "viewAllImages": "Voir toutes les images",
                "galleryTitle": "Galerie de photos",
                "cancelationTerms": "Conditions d'annulation - ",
                "nameOfTheHotel": "Détails de l'hôtel",
                "hotelInfo": "À propos de l'hôtel",
                "hotelWebsite": "Lien vers le site de l'hôtel",
                "showMore": "Afficher plus",
                "showLess": "Afficher moins"
            },
            "manageBaggage": {
                "manageBaggage": "Gérer les bagages",
                "and": "Et",
                "save": "Sauvegarder",
                "purchaseIsNotSupported": "l'achat n'est pas pris en charge",
                "baggageIsForBothFlights": "Vous pouvez ajouter des bagages pour un vol aller-retour",
                "suitcase": "Valise",
                "trolly": "Chariot",
                "guest": "Invité"
            },
            "shoppingCartTranslations": {
                localInventoryAlert:"Commande avec forfait spécial, actuellement non disponible en consultation - uniquement pour le paiement",
                skyInventory:"Inventaire SKY",
                recommendedHotel:"Hôtel recommandé",
                recommendedFlight:"Vol recommandé",
                "dynamicPackageTitleRemark": "Le prix inclut le vol et l'hôtel - chaque produit a ses propres conditions et termes",
                "dynamicPackageTitleRemarkEvents": "Le prix inclut le vol, l'hôtel et l'événement - chaque produit a ses propres conditions et termes",
                "productIsApproved": "Ce produit a été approuvé",
                "productIsNotApproved": "Ce produit n'a pas été approuvé",
                "waitingToApprove": "Ce produit est en cours de traitement",
                "productIsCancelled": "Ce produit a été annulé",
                "orderIsApproved": "Cette commande a été approuvée !",
                "orderIsNotApproved": "Cette commande n'a pas été approuvée !",
                "orderBeingProcessed": "Cette commande est en cours de traitement",
                "orderIsCancelled": "Cette commande a été annulée !",

                'attractionPriceDescription': "Le prix de l'attraction dépend de la date, du choix des options et du nombre de billets",
                "selectedDate": "Date sélectionnée",
                "selectADate": "Sélectionnez une date",
                "availableDatesBetween": "Dates disponibles entre",
                "Options": "Options",
                "Text": "Texte",
                "Ticket type": "Type de billet",
                "Start Time": "Heure de début",
                'Guide language': "Langue du guide",
                "Pick Up Location": "Lieu de prise en charge",
                "Custom Pick Up Location": "Lieu de prise en charge personnalisé",
                "Drop Off Location": "Lieu de dépose",
                "Custom Drop Off Location": "Lieu de dépose personnalisé",

                "manageBaggage": "Gérer les bagages",
                "youCanAddGuestsOnlyUpToTheAvailableSeats": "Vous pouvez ajouter des invités uniquement jusqu'au nombre de places disponibles",
                "paxExceedsAuthorizedSeats": "Le nombre de passagers dépasse le nombre de sièges autorisés à ce tarif – veuillez noter que la réservation sera en demande et que le prix est sujet à changement",
                "paxExceedsAvailableSeats": "Le nombre de passagers dépasse le nombre de sièges disponibles – veuillez noter que la réservation sera soumise à l'approbation du fournisseur et que le prix peut changer",
                "shoppingCartButtonTooltip": "Choisissez une composition et ajoutez à la commande",
                "totalPrice": "Total à payer",
                "proceedToPayment": "Procéder au paiement",
                "placeOrder": "Procéder à l'enregistrement",
                "NoHotelWasChosenForTheVacation": "Aucun hôtel n'a été choisi pour les vacances",
                "betweenDates": "Entre les dates",
                "packageInformation": "Détails du forfait",
                "rooms": "Détails de la chambre",
                "transfers": "Transferts",
                "round_trip_transfers": "Transferts aller-retour à l'hôtel/navettes",
                "reg_transfers": "Transferts/navettes vers et depuis l'hôtel",
                "shuttle_transfers": "Navettes de la frontière à l'hôtel et retour",
                "flights": "Vols",
                "activities": "Attractions",
                "shoppingCart": "Panier",
                "package": "Nuits à l'hôtel",
                "nights": "Nuits",
                "inHotel": "À l'hôtel",
                "apply": "Confirmer",
                "promoCode": "Code promo",
                "yourShoppingCart": "Votre panier",
                "isEmpty": "Encore vide...",
                "myVacation": "Mes vacances",
                "showAll": "Afficher tout »",
                "beforeDiscount": "Total avant remise -",
                "agentCommission": "Commission de l'agent -",
                "agentCommissionNet": "Commission de l'agent (paiement net) -",
                "discountFromCode": "Remise avec code -",
                "affiliateWith": "En collaboration avec -",
                "tpId": "ID de commande -",
                "chargeTypeFullCC": "Paiement intégral - y compris la commission",
                "chargeTypeNetCC": "Paiement par abonnement pour le prix net",
                "chargeTypeCash": "Transaction en espèces",
                "agentCommissionPrec": "Pourcentage de commission de l'agent",
                "priceOff": "Remise",
                "percentageOff": "Pourcentage de remise",
                "selectedItems": "Articles sélectionnés",
                "viewProduct": "Voir un produit",
                "infantAdditionalPrice": "Prix supplémentaire pour bébé",
                "netPriceWarning": "Prix net, veuillez ajouter du profit !",
                "copyOrderLink": "Copier le lien",
                "createOrder": "Enregistrer l'offre",
                "createOrderError": "Échec de l'enregistrement de l'offre, veuillez réessayer",
                "updateCommission": "Enregistrer",
                "commissionNotSaved": "Veuillez cliquer pour enregistrer !",
                "clearCart": "Cliquez pour vider le panier",
                "assignCustomer": "Attribuer un client",
                "firstName": "Prénom",
                "lastName": "Nom",
                "phone": "Téléphone",
                "comment": "Commentaire",
                "email": "Email",
                "wrongEmailFormat": "Format d'e-mail incorrect",
                "saveCustomer": "Enregistrer le client",
                "updateCustomerTitle": "Mettre à jour le client",
                "createCustomerTitle": "Créer un nouveau client",
                "avgPricePerPerson": "Ajouter le prix moyen par personne",
                "avgPricePerPersonLine": "Prix moyen par personne",
                "totalPaxLabel": "Nombre de passagers",
                "sendByWhatsApp": "Envoyer par WhatsApp",
                "copyText": "Copier le texte",
                "copyQuoteTakanonLine": "Veuillez vous assurer que vous avez lu et approuvé les conditions générales avant l'achat\nLien vers les conditions générales: {domain}/takanon",
                "copyWithOrgDays": "Copier l'offre complète avec le programme journalier",
                "orgItineraryHeader": "Programme journalier",
                "orgTourPackageLine": "Circuit organisé vers {destination}, Nom du circuit: {tourName}, {nights}, {dateStart} - {dateEnd}",
                "packageToDestinationLine": "Pack vacances à {destination}",
                "sendBySMS": "Envoyer par SMS",
                "findQuoteFor": "Envoyer une offre via",
                "linkIsGive": "L'offre est en direct",
                "dates": "Dates",
                "hotelName": "Nom de l'hôtel",
                "flightPrice": "Prix du vol",
                "suitcase": "Valise",
                "trolly": "Chariot",
                "passengers": "Passagers",
                "totalAgentComm": "Commission totale de l'agent",
                "agentOptions": "Options de l'agent",
                "compareDisableForAgent": "La comparaison de prix est disponible lorsque deux devis sont dans le panier",
                "createNewUser": "Créer une nouvelle offre",
                "comparePrice": "Comparer les prix",
                "send": "Envoyer l'offre",
                "profitPercentageChange": "Modifier le profit",
                "or": "Ou",
                "approval": "Approbation",
                "profitPerPerson": "Profit par personne",
                "grossProfitPercentage": "Pourcentage de profit",
                "grossProfitPercentageInvalidRange": "Le pourcentage de profit doit être compris entre 0 et 99",
                "commissionMixedCurrencyTitle": "Comment la commission a été calculée",
                "commissionMixedCurrencyNote": "La commission est répartie entre les éléments ci-dessous et ajoutée à chacun dans sa propre devise, puis convertie.",
                "commissionFlightLabel": "Vol",
                "commissionRoomLabel": "Chambre",
                "commissionTotalLabel": "Total",
                "actionNotAllowed": "Action non autorisée",
                "orderIsAlreadySaved": "La commande est déjà enregistrée et aucun produit supplémentaire ne peut être ajouté",
                "clickToClear": "Cliquez pour vider le panier",
                "roomsByRequestSubjectOfHotelAvailability": "Impossible d'ajouter le même type de chambre, veuillez en sélectionner un autre",
                "roomApprovalIsSubjectToRoomAvailability": "L'approbation de la chambre est soumise à la disponibilité de la chambre",
                "unableToAddRoomToSamePackage": "Impossible d'ajouter la chambre au même forfait",
                "roomsByRequestSubjectOfHotelAvailabilityTitle": "Échec de l'ajout de la chambre",
                "youReachedMaxRooms": "Vous avez atteint le nombre maximum de chambres",
                "eventTicketAlreadyAdded": "Impossible d'ajouter le même type de billet, veuillez en sélectionner un autre",
                'failedToAddEventTicket':"Échec de l'ajout de billet d'événement",
                "eventTicketPaxMismatchTitle": "Le nombre de billets et de passagers ne correspond pas",
                "eventTicketPaxMismatch": "Le nombre de billets d'événement sélectionnés ne correspond pas au nombre de passagers (vol/chambre). Veuillez mettre à jour la quantité de billets ou la sélection de chambre.",

                "attractionAlreadyAdded": "Impossible d'ajouter le même type d'attraction, veuillez sélectionner un type d'attraction différent",
                "failedToAddAttraction": "Échec de l'ajout de l'attraction",
                "noAvailabilityOnThisDates": "Aucune disponibilité pour les dates sélectionnées",
                "attractionSearchFailed": "Échec de la recherche d'attraction",
                "cannotSearchForThePastDates": "Impossible de rechercher des dates passées",
                "searchOtherForDates": "Aucune disponibilité, veuillez rechercher d'autres dates disponibles",
                "adult": "Adulte",
                "child": "Enfant",
                "infant": "Bébé",
                "perPerson": "Par personne",
                "perVehicle": "Par véhicule",
                "group": "Groupe",
                "family": "Famille",
                "perEquipment": "Par équipement",
                "perBoat": "Par bateau",
                "none": "Aucun"
            },
            "checkout": {
                "cityOfBirth": "Ville de naissance",
                "nationalityCountryId": "Pays de nationalité",
                "fill_out_at_least_one_guest_fields": "Veuillez remplir tous les champs pour au moins un invité !",
                "addRestOfGuests": "Add Rest Of Guests",
                "hideRestOfGuests": "Hide Rest Of Guests",
                "addBaggage": "Ajouter des bagages",
                "newGuest": "Nouvel invité",
                "selectGuest":"Sélectionner un invité",
                "chooseExistingGuest": "Utiliser un invité existant",
                "additionalBaggage": "Bagages supplémentaires",
                "free": "gratuit",
                "baggageIsForBothFlights": "Vous pouvez ajouter des bagages pour un vol aller-retour",
                "additionalBaggageForThisGuest": "Bagages supplémentaires pour cet invité",
                "orderFailedToLoad": "Une erreur s'est produite lors du chargement de l'offre",
                "cartNoLongerValid": "Le panier n'est plus valide",
                "room": "Chambre",
                "personalInfo": "Détails de la commande",
                "paymentDetails": "Paiement",
                "orderCompletion": "Terminer la commande",
                "userDetails": "Informations du client",
                "name": "Prénom",
                "lastName": "Nom de famille",
                "passport": "Passeport",
                "inEnglish": "",
                "birthdate": "Date de naissance",
                "phone": "Téléphone",
                "email": "Email",
                "notesForTheOrder": "Remarques pour la commande",
                "namesOfGuests": "Passagers",
                "namesMustMatchPassport": "* Tous les noms doivent être saisis en anglais exactement comme sur le passeport",
                "goToPayments": "Soumettre et procéder au paiement",
                "saveAndCommit": "Enregistrer et valider l'offre",
                "saveAndPayLater": "Enregistrer et payer plus tard",
                "saveOrder": "Enregistrer la commande",
                "agreement": "Je confirme les conditions du site, les conditions de commande et les conditions d'annulation de la commande",
                "men": "Homme",
                "women": "Femme",
                "pleaseInputYourPhone": "Veuillez entrer votre numéro de téléphone",
                "pleaseInputYourLastName": "Veuillez entrer votre nom de famille",
                "pleaseInputYourFirstName": "Veuillez entrer votre prénom",
                "pleaseInputYourEmail": "Veuillez entrer votre email",
                "pleaseInputYourPassportNumber": "Veuillez entrer votre numéro de passeport",
                "pleaseInputYourDateOfBirth": "Veuillez entrer votre date de naissance",
                "pleaseSelectGender": "Veuillez sélectionner le sexe",
                "maxChildAge": "Enfant entre les âges de 2-",
                "maxInfantAge": "Les bébés doivent avoir moins de deux ans au moment des vacances",
                "pleaseAgreeWithT&C": "Veuillez accepter les conditions d'utilisation et le règlement du site",
                "viewTerms": "Voir le règlement",
                "invalidEmail": "Email invalide",
                "orderCreateSuccess": "Votre commande a été enregistrée avec succès, vous êtes redirigé vers le paiement",
                "orderCreateFree": "Votre commande a été enregistrée avec succès !",
                "orderUpdateSuccess": "Votre commande a été mise à jour avec succès !",
                "mainRoomGuestTitle": "Chambre au nom de",
                "uploadPassportImage": "Télécharger la photo du passeport",
                "addInfant": "Ajouter un bébé",
                "updateInfant": "Mettre à jour la quantité de bébés",
                "howManyInfantsDoYouWantToAdd": "Choisissez le nombre de bébés pour cette chambre",
                "add": "Ajouter",
                "setInfantCountForRoom": "Mettre à jour la quantité de bébés",
                "setInfantCountForRoomSuccess": "Le nombre de bébés a été mis à jour avec succès",
                "infantsAddedToTheRoom": "Bébés ajoutés à la chambre",
                "selectNumberOfInfants": "Choisissez le nombre de bébés",
                "pricePerInfant": "Prix par bébé",
                "infantsRemoved": "Les bébés ont été retirés de cette chambre",
                "requiredUploadPassportImage": "Le téléchargement de la photo du passeport est obligatoire",
                "infantError4403": "Impossible de changer le nombre de bébés - veuillez contacter le centre de service",
                "docketId": "* ID du dossier",
                "agencyId": "* ID de l'agence",
                "documentType": "Type de document",
                "documentTypeInfo": "Choisissez la carte d'identité pour les vols intérieurs",
                "documentTypePassport": "Passeport",
                "documentTypeIdCard": "Carte d'identité",
                "issuingCountry": "Pays d'émission",
                "residenceCountry": "Pays de résidence",
                "nationality": "Nationalité",
                "documentNumber": "Numéro de document",
                "documentNumberPassport": "Numéro de passeport",
                "documentNumberIdCard": "Numéro de carte d'identité",
                "pleaseInputPassportNumber": "Veuillez entrer le numéro de passeport",
                "pleaseInputIdCardNumber": "Veuillez entrer le numéro de carte d'identité",
                "expirationDate": "Date d'expiration",
                "pleaseSelectDocumentType": "Veuillez sélectionner le type de document",
                "pleaseSelectIssuingCountry": "Veuillez sélectionner le pays d'émission",
                "pleaseSelectResidenceCountry": "Veuillez sélectionner le pays de résidence",
                "pleaseSelectNationality": "Veuillez sélectionner la nationalité",
                "pleaseInputDocumentNumber": "Veuillez saisir le numéro de document",
                "pleaseSelectExpirationDate": "Veuillez sélectionner la date d'expiration"
            },
            "manageOrder": {
                moveToPaymentWarning: "Les informations du client ne sont pas enregistrées et les informations des invités sont vides ! Êtes-vous sûr de vouloir continuer ?",
                moveToPaymentWarning1: "Les informations du client ne sont pas enregistrées. Êtes-vous sûr de vouloir continuer ?",
                moveToPaymentWarning2: "Les informations des invités sont vides ! Êtes-vous sûr de vouloir passer au paiement ?",
                "moveToPayment": "Ajouter un paiement",
                "backToManage": "Retourner à la commande",
                "paymentTitle": "Paiement de la commande",
                "manageTitle": "Mettre à jour les informations de la commande",
                "modelNotFound": "Commande non trouvée",
                "failToLoad": "Impossible de charger les détails de votre commande, veuillez réessayer plus tard.",
                "orderId": "Gestion de la commande",

                "room_booking_cancelled_successfully": "Réservation de la chambre annulée avec succès",
                "room_booking_cancel_error": "Erreur lors de l'annulation de la réservation de la chambre",
                "cancel_room_booking_warning": "En annulant la chambre, vous perdrez la réservation et le prix. Êtes-vous sûr ?",
                "cancel_booking": "Annuler la réservation",
                "incompleteDPsWereRemoved": 'Les forfaits dynamiques incomplets ont été supprimés de votre panier. Veuillez les ajouter à nouveau avec à la fois hôtel+vol et billets d\'événement.',
            },
            "completionForm": {
                "paymentFinish": {
                    "title": "La commande a été effectuée avec succès - paiement complété",
                    "info": "Un email avec les détails de la commande a été envoyé à votre adresse"
                },
                "waitingToApprove": {
                    "title": "Votre commande a été envoyée pour approbation",
                    "info1": "Les détails de la commande ont été enregistrés dans le système et envoyés pour approbation.",
                    "info2": "Le paiement sera effectué uniquement après l'approbation de la commande.",
                    "info3": "Un email de confirmation de commande et de paiement sera envoyé après l'approbation de la commande."
                },
                "paymentFail": {
                    "title": "Échec du paiement",
                    "info1": "Le paiement a échoué :(",
                    "infoFail": "Après plusieurs tentatives, la facturation a échoué - veuillez réessayer",
                    "infoWhatsapp": "Si une erreur s'est produite et que vous ne pouvez pas payer, veuillez contacter via WhatsApp au :"
                },
                "orderNum": "Numéro de commande",
                "thanksForChoose": "Merci d'avoir choisi",
                "free": {
                    "title": "L'inscription a réussi",
                    "info": "Un email avec un résumé de la commande vous a été envoyé"
                },
                "pay_later": {
                    "title": "L'inscription a réussi",
                    "info": "Un email de confirmation de commande vous a été envoyé"
                }
            },
            "paymentForm": {
                "card": "Carte de crédit",
                "creditCardInterest": "Intérêt de la carte de crédit",
                "interest": "intérêt",
                "monthlyPayments": "Paiements mensuels",
                "monthsCount": "Nombre de mois",
                "priceCanNotBeOverBalance": "Le prix ne peut pas dépasser le solde",
                "total": "Lien total",
                "balance": "Solde total",
                "updatedBalance": "solde mis à jour",
                "copyLink": "Copier le lien",
                "linkFor": "Lien pour",
                "back": "Retour",
                "setSpecificPrice": "Lien de paiement",
                "createLink": "Créer un lien",
                "setPriceAndSendPaymentLinkToClient": "Définir le prix et envoyer le paiement au client",
                "clientName": "Nom du client",
                "paymentPageFor": "Page de paiement pour",
                "forPayment": "Pour paiement",
                "price": "Prix",
                "copyPaymentLink": "Copier le lien de paiement",
                "pleaseFillInBothFields": "Veuillez remplir les deux champs.",
                "paymentLinkCopiedToClipboard": "Lien de paiement copié dans le presse-papiers !",
                "createLinkForPrice": "Créer un lien pour le paiement",
                "creditNotSaveInBd": "Les détails de la carte de crédit ne sont pas enregistrés sur le site - vous effectuez un paiement sécurisé",
                "title": "Entrez la méthode de paiement (Visa & Mastercard UNIQUEMENT)",
                "splitBtn": "Cliquez pour diviser les cartes de crédit",
                "splitTitle": "Diviser les cartes de crédit",
                "splitDesc": "Choisissez le nombre de cartes de crédit à diviser et cliquez sur confirmer",
                "noSplit": "Pas de division",
                "noPayments": "Pas de paiements",
                "payments": "Paiements",
                "paymentsNum": "Nombre de paiements",
                "withDebit": "Avec crédit",
                "splitBy": "Cartes de crédit",
                "toPay": "À payer",
                "splitApprove": "Confirmer",
                "currencyRate": "La facturation est effectuée en shekels - selon le taux du tourisme",
                "splitCurrentCardNum": "Division de crédit",
                "splitCurrentCardNumFrom": "Sur",
                "errorMessageToRetry": "Tentative n° {retryNum} - Échec du paiement par la société émettrice de la carte de crédit. Veuillez entrer à nouveau les détails de la carte ou une autre carte. Le site n'accepte que les cartes VISA et MASTERCARD.",
                "installments": "Versements",
                "installmentsLabel": "Nombre de versements",
                "installmentFee": "Frais de versement",
                "totalToPay": "Total à payer",
                "perMonth": "par mois",
                "installmentsDisclosure": "Les versements sont traités par l'émetteur de votre carte. Le total comprend des frais de versement."
            },
            "hotelTypes": {
                "Hotel": "Hôtel"
            },
            "hotelDetails": {
                "updateDates": "Mettre à jour les dates",
                "roomTypesToChooseFrom": "Types de chambres à choisir",
                "metapolicy": "Politique de l'hôtel",
                "metaExtraInfo": "Informations supplémentaires",
                "not_included": "Non inclus",
                "included": "Inclus",
                "price": "Au coût de",
                "address": "Adresse",
                "other": "Adresse",
                "Location": "Emplacement de l'hôtel",
                "At the boutique hotel": "À propos de l'hôtel",
                "Room amenities": "Équipements de la chambre",
                "parking": "Parking",
                "pets": "Animaux domestiques",
                "shuttle": "Navette vers l'aéroport (aller simple)",
                "internet": "Services Internet",
                "extra_bed": "Lit supplémentaire",
                "add_fee": "Frais supplémentaires",
                "children_meal": "Repas pour enfants",
                "check_in_check_out": "Arrivée et départ"
            },
            "sideFilters": {
                "sortBy": "Trier par",
                "price_asc": "Prix le plus bas",
                "price_desc": "Prix le plus élevé",
                "hotel_stars_asc": "Nombre d'étoiles le plus bas",
                "hotel_stars_desc": "Nombre d'étoiles le plus élevé",
                "distance": "Distance",
                "distance_asc": "Distance la plus proche",
                "distance_desc": "Distance la plus éloignée",
                "recommended": "Recommandé",
                "price": "Prix",
                "clearSideFilters": "Effacer les filtres",
                "ts_type": "Types de vol",
                "auto_approve": "Approbation instantanée",
                "include_transfer": "Inclure le transfert",
                "include_baggage": "Inclure les bagages",
                "include_trolly": "Inclure le chariot",
                "auto_approve_checked": "Affichage des résultats d'approbation instantanée",
                "from_date_hours": "Heure de départ du vol aller",
                "isSpecial": "Est spécial",
                "is_special": "Est spécial",
                "date_range": "Durée de séjour",
                "from_date_landing_hours": "Heure d'arrivée du vol aller",
                "flight_stop_time": "Heure de l'arrêt",
                "return_date_landing_hours": "Heure d'arrivée du vol retour",
                "return_date_hours": "Heure de retour du vol",
                "airline": "Compagnie aérienne",
                "2": "Vols charter",
                "3": "Vols réguliers",
                "nonStop": "Vol direct",
                "stop": "Une escale",
                "stops_plural": "Escales",
                "hotel_type": "Types d'hébergement",
                "stops": "Nombre d'escales",
                "freeCancellation": "Annulation gratuite ?",
                "freeCancellationLabels": {
                    "1": "Uniquement annulation gratuite",
                    "0": "Sans annulation gratuite"
                },

                "feature": "Caractéristique",

                "event_type": "Types d'événements",
                "avenue": "Avenue",
                "event_date": "Date de l'événement",
            },
            "package_feature": {
                "SPECIAL PACKAGE": "Forfait spécial",
                "ALL PACKAGES": "Tous les forfaits",
                "KOSHER": "Kascher",
                "TOUR": "Tour",
                "SKI": "Ski",
                "EVENT": "Événement",
                "SPORT": "Sport",
                "SPA": "Spa",
                "YOUNG VACATION": "Vacances jeunes",
                "FLT+HTL+CAR": "Vol+Hôtel+Voiture"
            },
            "hotelAmenities": {
            },
            "general": {
                "km": "KM",
                "kmFromVenue": "KM de l'emplacement",
                "kmFromCityCenter": "KM du centre-ville",
                openBO: "Ouvrir le back-office",
                logOut: "Se déconnecter",
                "toOrder": "À commander",
                "amount": "Montant",
                parentOriginal: "Original parent",
                parentEdited: "Édité par le parent",
                "fetchingMoreResults": "Chargement de plus de résultats...",
                "error": "Erreur",
                "somethingWentWrong": "Une erreur s'est produite. Veuillez réessayer.",
                "noResultsFound": "Aucun événement trouvé",
                "tryAdjustingFilters": "Essayez de modifier vos filtres ou vos critères de recherche",
                "refresh": "Actualiser",
                "list": "Liste",
                "matched": "Coincidence",
                "rates": "Tarifs",
                "calculatedRates": "Tarifs calculés",
                "selected": "Sélectionné",
                "to": "à",
                "roomOnly": "Chambre seulement",
                "close": "Fermer",
                "language": "Langue",
                "remark": "Remarque",
                "addService": "Ajouter un service",
                packagesMainTitle: "Forfaits vacances",
                vacationAtHeader: "Vacances à",
                additionalFlights: "Vols supplémentaires",
                daysOfStay:"Jours de séjour",
                lowPrice: "Prix bas",
                flightUpTo: "Vol à partir de",
                flightsPromoTitle: "derniers vols",
                "additionalPackages": "Forfaits supplémentaires",
                "packagePlan": "Forfaits vacances à partir de",
                "immediateApproval": "Approbation immédiate",
                "total": "Total",
                "as_of_today": "à ce jour",
                "priceInIls": "({price} ₪)",
                "link_to_the_offer": "Lien vers l'offre",
                "the_quote_has_been_copied_successfully": "Le devis a été copié avec succès",
                "base": "Base",
                "usd": "USD",
                "euro": "EURO",
                "address": "Adresse",
                "type": "Type",
                "noResults": "Aucun résultat",
                "boardBasis": "Base de pension",
                "nights": "Nuits",
                "supplier": "Fournisseur",
                "airLine": "Compagnie aérienne",
                "price": "Prix",
                "totalRoomPrice": "Prix total",
                "totalPrice": "Prix total",
                "priceForXRooms": "Prix pour X chambres",
                "hotel": "Hôtel",
                "hotel_stars": "Étoiles de l'hôtel",
                "minPrice": "Prix minimum",
                "BB": "BB",
                "HB": "HB",
                "cancel": "Annuler",
                "replaceShoppingCart": "Remplacer le panier",
                "replace": "Remplacer",
                "searchForUser": "Rechercher un utilisateur",
                "acceptCookiesTitle": "Ce site utilise des cookies pour vous garantir la meilleure expérience sur notre site.",
                "acceptCookiesBtn": "Accepter",
                "includesActivities": "{NUMBER} attractions offertes !",
                "includesActivity": "Inclut une attraction offerte !",
                "adults": "Adultes",
                "all_include": "Tout inclus",
                "breakfast": "Petit-déjeuner",
                "half_board": "Demi-pension",
                "half_board_kosher": "Demi-pension casher",
                "full_board": "Pension complète",
                "sleep_only": "Hébergement uniquement",
                "breakfast_kidush": "Petit-déjeuner et dîner du vendredi",
                "addToCard": "Ajouter à la commande",
                "chooseRoom": "Choisissez la composition et la chambre",
                "boardType": "Base d'hébergement",
                "filters": "Filtres",
                "rating": "Évaluation de l'hôtel",
                "event": "Événement",
                "children": "Enfants",
                "tickets": "Billets",
                "deliveryMethod": "Mode de livraison",
                "toDate": "Jusqu'à",
                "transfers": "Transferts",
                "from": "À partir de",
                "perPerson": "Par personne",
                "include": "Inclut",
                "noIncludeText": "Forfaits vacances",
                "flights": "Vols",
                "vacationAt": "Vacances à {DEST}",
                "fieldRequired": "Champ obligatoire",
                "showAll": "Afficher tout",
                "showLess": "Afficher moins",
                "flight": "vol",
                "h": "h",
                "min": "min",
                "availableSeats": "Places disponibles",
                "showGrossPrice": "Afficher le prix brut",
                "showNetPrice": "Afficher le prix net",
                "noRating": "Aucune évaluation",
                "bundleFlight": "Vol aller-retour",
                "oneWayBundleFlight": "Vol aller simple",
                "trollyIsIncluded": "Chariot inclus",
                "trollyIsNotIncluded": "Pas de chariot",
                "suitcaseIsIncluded": "Valise incluse",
                "suitcaseIsNotIncluded": "Valise non incluse",
                "additionalSuitcases": "Inclut X valises",
                "additionalTrolly": "Inclut X chariots",
                "returnFlight": "Vol retour",
                "outboundFlight": "Vol aller",
                "agentMode": "Mode agent",
                "userMode": "Mode client",
                "suitcase": "Valise",
                "trolly": "Chariot",
                "packageSearchResult": "Les forfaits que nous avons trouvés pour vous",
                "day": "Jour",
                "selectDate": "Sélectionner les dates",
                "search": "Rechercher",
                "adult": "Adulte",
                "child": "Enfant",
                "infant": "Bébé",
                "infants": "Bébés",

                "loading": "Chargement",
                "showingMoreResults": "Affichage de plus de résultats",
                "noMoreResults": "Plus de résultats",
                "NoResultsMatchedTheFilterValues": "Aucun résultat ne correspond aux valeurs du filtre",
                "eventTicketsAdded": "Billets d'événement ajoutés",
                "addEventTickets": "Ajouter des billets d'événement",
                "add": "Ajouter",
            },
            "subsidizedForm": {
                "title": "Ajouter une subvention",
                "employee_id": "Numéro d'employé",
                "person_id": "Numéro d'identité (9 chiffres)",
                "validate": "Vérifier le code employé",
                "alreadyApplied": "Subvention déjà appliquée",
                "addOneMore": "Ajouter une autre subvention",
                "addOneMoreId": "Ajouter un autre employé",
                "fieldRequired": "Champ obligatoire",
                "priceReducedBy": "Prix réduit de",
                "forEmployee": "Pour l'employé",
                "employeeIs": "Identifié avec succès",
                "error4401": "Échec de l'identification, réessayez",
                "error4402": "Code identifié, mais déjà utilisé",
                "guestIdentifiedId": "Identifié par ID",
                "guestNotIdentified": "Vous devez vous identifier avant de vous inscrire",
                "clickToIdentify": "Cliquez pour identifier"
            },
            "uploadImage": {
                "uploadPassportImage": "Télécharger la photo du passeport",
                "somethingWentWrong": "Quelque chose s'est mal passé"
            },
            "flightButton": {
                "no_availability_for_this_flight_price": "Désolé, mais il n'y a plus de disponibilité pour ce tarif de vol",
                "cardConditions": "Conditions de la carte",
                "flightTotalPrice": "Prix du vol aller simple",
                "total": "Total",
                "continueToOrder": "Passer à la commande",
                "addToCart": "Ajouter au panier",
                "lastPlace": "Dernières places disponibles",
                "pricePerPassenger": "Prix par passager"
            },
            "agentCommission": {
                "supplier": "Fournisseur",
                "commission": "Commission",
                "recommendedFee": "Frais recommandés",
                "transactionDetailsForAgent": "Détails de l'agent",
                "supplierNotes": "Notes du fournisseur",
                "cancellationConditions": "Conditions d'annulation",
                "addToCartToChangeFree": "Ajouter au panier pour changer la commission",
                "pricesShownAreNetPrices": "Les prix affichés sont nets",
                "pricesShownAreGrossPrices": "Les prix affichés sont bruts",
                "packageRemarks": "Remarques sur le forfait"
            },
            "onboarding": {
                "openOnboarding": "Guide",
                "welcomeTitle": "Bienvenue sur Sky360",
                "subtitle": "Profitez au maximum de notre plateforme avec cette visite rapide. Complétez chaque étape pour explorer tout ce que nous offrons.",
                "progressTitle": "Votre progression",
                "progressLabel": "Complété",
                "continueOnboarding": "Continuer",
                "yourPath": "Étapes d'intégration",
                "pathSubtitle": "Suivez ces étapes pour explorer tous nos produits.",
                "markAsDone": "Marquer comme terminé",
                "upNext": "SUIVANT",
                "continue": "Continuer",
                "outcomesTitle": "CE QUE VOUS APPRENDREZ",
                "outcome1": "Recherche et réservation",
                "outcome1Desc": "Trouvez des forfaits, vols, hôtels et plus encore.",
                "outcome2": "Événements et attractions",
                "outcome2Desc": "Découvrez des expériences locales à votre destination.",
                "stepCompleted": "Complété",
                "stepCompletedBanner": "Étape complétée ! Vous progressez très bien.",
                "stepCompletionTitle": "Étape {num} terminée !",
                "stepCompletionKicker": "Bon travail — gardez le rythme !",
                "tasksCompleted": "Tâches : {done}/{total} complétées",
                "typeTask": "FAIRE",
                "stepLabel": "ÉTAPE",
                "nextStepHint": "Suivant : Étape {num} — {title}",
                "continueUpNext": "Commencer",
                "tourFinishBtn": "Terminé",
                "tourNextBtn": "Suivant",
                "tourPrevBtn": "Précédent",
                "tourActionHint": "👆 Cliquez sur le bouton ci-dessus pour continuer",
                "typeLearn": "APPRENDRE",
                "steps": {
                    "step1": { "title": "Rechercher des forfaits vacances", "description": "Apprenez à trouver et réserver des forfaits tout compris avec vols et hôtels." },
                    "step2": { "title": "Rechercher des vols", "description": "Trouvez des vols aller simple ou aller-retour, configurez les passagers et les dates." },
                    "step3": { "title": "Rechercher des hôtels", "description": "Parcourez les hôtels du monde entier par destination, dates et nombre de voyageurs." },
                    "step4": { "title": "Explorer les attractions", "description": "Découvrez des activités locales et des attractions touristiques." },
                    "step5": { "title": "Trouver des événements", "description": "Parcourez les événements à venir et combinez-les avec un vol et un hôtel." },
                    "step6": { "title": "Aperçu du moteur de recherche", "description": "Passez entre tous les types de produits en un seul endroit." },
                    "step7": { "title": "Recherche de forfait dynamique", "description": "Apprenez à créer un voyage sur mesure en sélectionnant une destination ou un hôtel et en ajoutant un vol direct." },
                    "step8": { "title": "Créer une réservation de vol", "description": "Parcourez le processus complet de réservation de vol — de la recherche jusqu'au paiement." },
                    "step9": { "title": "Aperçu du panneau agent", "description": "Le bandeau agent en haut du B2C vous permet de gérer les clients, changer les modes de tarification, voir votre solde Diamonds et plus encore." },
                    "step10": { "title": "Créer une réservation de forfait", "description": "Parcourez le processus complet de réservation de forfait — de la recherche jusqu'au paiement." },
                    "step11": { "title": "Explorer la page de gestion de commande", "description": "Parcourez la page de gestion de commande — consultez les détails de la réservation, mettez à jour les informations des invités et accédez à la section de paiement." }
                },
                "tour": {
                    "seModHoverTitle": "Explorer les actions du module",
                    "seModHoverDesc": "Survolez n'importe quel module dans la page ci-dessous — une petite barre d'actions apparaît pour ce module. Survolez-en un maintenant pour découvrir ce que fait chaque action.",
                    "seModAddTopTitle": "Ajouter un module au-dessus",
                    "seModAddTopDesc": "Insère un tout nouveau module directement au-dessus de celui-ci. Cliquez pour choisir un type de module et le placer.",
                    "seModReorderTitle": "Réorganiser ce module",
                    "seModReorderDesc": "Utilisez les flèches haut et bas pour déplacer ce module plus tôt ou plus tard sur la page. L'aperçu se réorganise instantanément.",
                    "seModEditTitle": "Modifier ce module",
                    "seModEditDesc": "Ouvre ce module dans le panneau de paramètres à gauche, où vous pouvez changer son contenu, sa mise en page et son style.",
                    "seModDeleteTitle": "Supprimer ce module",
                    "seModDeleteDesc": "Supprime ce module de la page. Vous pouvez toujours le rajouter plus tard via les options d'ajout de module.",
                    "seModAddBottomTitle": "Ajouter un module en dessous",
                    "seModAddBottomDesc": "Insère un tout nouveau module directement sous celui-ci — comme le bouton du haut, mais pour l'emplacement en dessous.",
                    "packagesDpSwitchTitle": "Forfaits dynamiques — vol + hôtel", "packagesDpSwitchDesc": "Passez en mode forfait dynamique — choisissez un hôtel et le système le combine avec le vol le moins cher disponible sur cet itinéraire, créant un prix de forfait complet et compétitif sur-le-champ.",
                    "packagesFeaturesTitle": "Catégories de forfaits", "packagesFeaturesDesc": "Choisissez le type de forfait vacances que vous recherchez — circuits organisés, voyages sportifs, voyages kasher et plus encore.",
                    "pkgSpecialTitle": "Forfaits spéciaux — Commission fixe de 10%", "pkgSpecialDesc": "Voici la catégorie des forfaits spéciaux — des voyages en groupe organisés par la plateforme. Chaque forfait spécial inclut une commission agence fixe de 10% déjà intégrée. Idéal pour une vente rapide et confiante — sans négociation de prix.",
                    "pkgOtherCatsTitle": "Autres catégories de forfaits", "pkgOtherCatsDesc": "Ce sont les autres catégories de forfaits — circuits organisés, voyages kasher, séjours ski, escapades spa, événements sportifs et plus encore. Chaque catégorie filtre automatiquement les forfaits et destinations disponibles.",
                    "pkgSelectCatTitle": "Essayez — sélectionnez une catégorie", "pkgSelectCatDesc": "Cliquez sur une carte de catégorie pour filtrer les forfaits par type. Regardez comment la liste de destinations se met à jour automatiquement.",
                    "pkgFilteredDestsTitle": "Destinations filtrées", "pkgFilteredDestsDesc": "Lorsqu'une catégorie est sélectionnée, la liste des destinations est filtrée automatiquement pour n'afficher que les lieux où des forfaits de ce type sont disponibles. Sélectionnez une destination pour continuer.",
                    "pkgDeselectCatTitle": "Cliquez à nouveau pour désélectionner", "pkgDeselectCatDesc": "Cliquer une deuxième fois sur la catégorie active la désélectionne — la liste des destinations revient à tous les forfaits disponibles. Essayez maintenant.",
                    "pkgDepartureTitle": "Ville de départ", "pkgDepartureDesc": "Sélectionnez l'aéroport ou la ville depuis laquelle vous volerez pour votre forfait.",
                    "packagesDestTitle": "Choisir la destination", "packagesDestDesc": "Sélectionnez une ou plusieurs destinations pour votre forfait.",
                    "packagesGuestsTitle": "Voyageurs", "packagesGuestsDesc": "Choisissez le nombre de voyageurs — adultes, enfants et bébés — pour votre forfait vacances.",
                    "packagesDatesTitle": "Dates de voyage", "packagesDatesDesc": "Choisissez les dates de départ et de retour pour le forfait.",
                    "packagesSearchTitle": "Rechercher des forfaits", "packagesSearchDesc": "Cliquez ici pour trouver les forfaits disponibles.",
                    "flightTripTypeTitle": "Type de trajet", "flightTripTypeDesc": "Basculez entre un vol aller simple et aller-retour.",
                    "flightDirectTitle": "Vols directs uniquement", "flightDirectDesc": "Activez ce bouton pour filtrer les résultats sur les vols directs uniquement — sans escales.",
                    "flightDepartureTitle": "Ville de départ", "flightDepartureDesc": "Sélectionnez l'aéroport ou la ville de départ.",
                    "flightArrivalTitle": "Destination", "flightArrivalDesc": "Sélectionnez l'aéroport ou la ville d'arrivée.",
                    "flightPaxTitle": "Passagers", "flightPaxDesc": "Définissez le nombre d'adultes, d'enfants et de nourrissons.",
                    "flightDatesTitle": "Dates de vol", "flightDatesDesc": "Choisissez la date de départ et de retour pour les vols aller-retour.",
                    "flightSearchTitle": "Rechercher des vols", "flightSearchDesc": "Cliquez pour rechercher les vols disponibles.",
                    "hotelDestTitle": "Destination de l'hôtel", "hotelDestDesc": "Recherchez la ville ou la région où vous souhaitez séjourner.",
                    "hotelGuestsTitle": "Chambres et voyageurs", "hotelGuestsDesc": "Ajoutez autant de chambres que nécessaire et configurez chacune séparément — définissez le nombre d'adultes, d'enfants et de bébés pour chaque chambre. Combinez librement les configurations pour s'adapter à n'importe quel groupe : couples, familles ou toute combinaison.",
                    "hotelDatesTitle": "Arrivée et départ", "hotelDatesDesc": "Choisissez vos dates d'arrivée et de départ.",
                    "hotelSearchTitle": "Rechercher des hôtels", "hotelSearchDesc": "Cliquez pour parcourir les hôtels disponibles.",
                    "attrDestTitle": "Ville de l'attraction", "attrDestDesc": "Saisissez ou sélectionnez la ville pour trouver des attractions.",
                    "attrDatesTitle": "Dates d'activité", "attrDatesDesc": "Choisissez la plage de dates pour les activités.",
                    "attrTypeTitle": "Type d'attraction", "attrTypeDesc": "Filtrez par catégorie — musées, activités de plein air, visites guidées et plus.",
                    "attrSearchTitle": "Trouver des attractions", "attrSearchDesc": "Cliquez pour rechercher les attractions disponibles.",
                    "eventsPackageTitle": "Inclure un forfait complet", "eventsPackageDesc": "Activez ce bouton pour combiner l'événement avec un vol et un hôtel.",
                    "eventsEventTitle": "Rechercher un événement", "eventsEventDesc": "Saisissez un nom d'événement ou parcourez les options disponibles.",
                    "eventsDatesTitle": "Dates de l'événement", "eventsDatesDesc": "Sélectionnez la plage de dates de l'événement.",
                    "eventsSearchTitle": "Trouver des événements", "eventsSearchDesc": "Cliquez pour rechercher les événements disponibles.",
                    "mainTabsTitle": "Choisir le type de recherche", "mainTabsDesc": "Utilisez ces onglets pour passer entre les forfaits, vols, hôtels, attractions et événements.",
                    "mainFormTitle": "Formulaire de recherche", "mainFormDesc": "Remplissez vos informations de voyage et cliquez sur Rechercher.",
                    "mainPkgTabTitle": "Forfaits vacances", "mainPkgTabDesc": "Trouvez des forfaits vacances tout compris combinant vols et hôtels. Cliquez sur cet onglet pour voir le formulaire de recherche de forfaits.",
                    "mainPkgFormTitle": "Formulaire de recherche de forfaits", "mainPkgFormDesc": "Définissez votre ville de départ, destination, dates de voyage et configuration des chambres. Chaque champ aide à trouver les options les plus adaptées à vos clients.",
                    "mainFltTabTitle": "Vols", "mainFltTabDesc": "Recherchez des vols individuels — aller simple ou aller-retour. Cliquez sur cet onglet pour voir le formulaire de recherche de vols.",
                    "mainFltFormTitle": "Formulaire de recherche de vols", "mainFltFormDesc": "Choisissez le type de trajet, les villes de départ et d'arrivée, les dates et le nombre de passagers. Activez 'Vols directs uniquement' pour exclure les escales.",
                    "mainHtlTabTitle": "Hôtels", "mainHtlTabDesc": "Recherchez des séjours en hôtel uniquement dans le monde entier. Cliquez sur cet onglet pour voir le formulaire de recherche d'hôtels.",
                    "mainHtlFormTitle": "Formulaire de recherche d'hôtels", "mainHtlFormDesc": "Saisissez votre destination, les dates d'arrivée et de départ, et la configuration des chambres. Ajoutez plusieurs chambres et configurez chacune séparément selon votre groupe.",
                    "mainAttrTabTitle": "Attractions", "mainAttrTabDesc": "Découvrez des activités locales, des visites guidées et des choses à faire dans n'importe quelle destination. Cliquez sur cet onglet pour voir le formulaire de recherche.",
                    "mainAttrFormTitle": "Formulaire de recherche d'attractions", "mainAttrFormDesc": "Sélectionnez une ville, une plage de dates et un type d'activité pour trouver des activités disponibles. Idéal pour ajouter des extras à toute réservation.",
                    "mainEvtTabTitle": "Événements", "mainEvtTabDesc": "Réservez des billets pour des concerts, matchs sportifs, festivals et plus — avec option forfait complet avec vol et hôtel. Cliquez sur cet onglet pour voir le formulaire.",
                    "mainEvtFormTitle": "Formulaire de recherche d'événements", "mainEvtFormDesc": "Recherchez des événements par nom ou destination et définissez vos dates. Activez 'Forfait complet' pour combiner l'événement avec un vol et un hôtel en une seule réservation.",
                    "dynDpSwitchTitle": "Vol + hôtel — forfait dynamique", "dynDpSwitchDesc": "Les forfaits dynamiques combinent l'hôtel de votre choix avec le vol le moins cher disponible sur l'itinéraire — créant un prix de forfait complet et compétitif sur-le-champ. Le système verrouille automatiquement le meilleur tarif de vol et le combine avec vos résultats d'hôtel.",
                    "dynDirectTitle": "Vol direct", "dynDirectDesc": "Quand activé, les résultats se limitent aux vols directs uniquement. Désactivez pour inclure les vols avec escale.",
                    "dynDepartureTitle": "Ville de départ", "dynDepartureDesc": "Sélectionnez l'aéroport ou la ville depuis laquelle vous volerez pour votre forfait dynamique.",
                    "dynDestTitle": "Destination ou nom d'hôtel", "dynDestDesc": "Recherchez par ville de destination pour parcourir tous les hôtels disponibles dans la région — ou saisissez un nom d'hôtel précis pour aller directement à cet établissement. Aller directement à un hôtel est plus rapide lorsque votre client a déjà une préférence, et vous aide à construire le meilleur forfait en quelques secondes.",
                    "dynDatesTitle": "Dates de séjour", "dynDatesDesc": "Choisissez vos dates d'arrivée et de départ à l'hôtel.",
                    "dynGuestsTitle": "Chambres et voyageurs", "dynGuestsDesc": "Ajoutez autant de chambres que nécessaire et configurez chacune séparément — définissez le nombre d'adultes, d'enfants et de bébés pour chaque chambre. Combinez les configurations pour correspondre au groupe de votre client : par exemple une famille avec enfants dans une chambre et un couple dans une autre.",
                    "dynSearchTitle": "Rechercher un forfait dynamique", "dynSearchDesc": "Cliquez pour rechercher les forfaits dynamiques disponibles pour votre destination, vos dates et vos voyageurs.",
                    "fltSearchActionTitle": "Rechercher un vol", "fltSearchActionDesc": "Remplissez vos informations de voyage et cliquez sur Rechercher pour voir les vols disponibles.",
                    "fltResOnewayDayTitle": "Navigation rapide par date", "fltResOnewayDayDesc": "Utilisez ces cartes de jours pour accéder rapidement à une autre date de départ et voir les prix mis à jour.",
                    "fltResOnewayFiltersTitle": "Filtrer les résultats", "fltResOnewayFiltersDesc": "Utilisez les filtres latéraux pour affiner les résultats par compagnie aérienne, plage de prix, nombre d'escales et horaires.",
                    "fltResOnewayCardsTitle": "Vols disponibles", "fltResOnewayCardsDesc": "Parcourez la liste des vols disponibles. Chaque carte affiche la compagnie, le numéro de vol, la durée, les escales et le prix.",
                    "fltResOnewayActionTitle": "Sélectionner votre vol", "fltResOnewayActionDesc": "Cliquez sur «Sélectionner un vol» sur n'importe quelle carte pour accéder à la page de détails de réservation.",
                    "fltResBundleTabTitle": "Aller-retour vs Dynamique", "fltResBundleTabDesc": "Passez entre «Choisissez vos vols vous-même» — incluant des segments flexibles en sens unique et la navigation par dates — et «Vols prédéfinis» — forfaits aller-retour.",
                    "fltResBundleFiltersTitle": "Filtrer les résultats", "fltResBundleFiltersDesc": "Utilisez les filtres latéraux pour affiner les résultats par compagnie aérienne, plage de prix, nombre d'escales et horaires.",
                    "fltResBundleCardsTitle": "Options de vols groupés", "fltResBundleCardsDesc": "Chaque carte affiche un forfait aller-retour complet avec les détails du vol et le prix total.",
                    "fltResBundleActionTitle": "Passer à la commande", "fltResBundleActionDesc": "Cliquez sur «Passer à la commande» sur votre vol préféré pour examiner les détails et l'ajouter au panier.",
                    "fltResBundleResumeActionTitle": "Passer à la commande", "fltResBundleResumeActionDesc": "Sélectionnez un vol groupé et cliquez sur «Passer à la commande» pour continuer.",
                    "fltResDynDayTitle": "Navigation rapide par dates", "fltResDynDayDesc": "Utilisez ces cartes de dates pour passer rapidement à une autre date de départ et voir comment les prix évoluent.",
                    "fltResDynFiltersTitle": "Filtrer les résultats", "fltResDynFiltersDesc": "Affinez les résultats par compagnie, escales, plage de prix et horaires de vol.",
                    "fltResDynOutboundTitle": "Vols aller", "fltResDynOutboundDesc": "Parcourez les vols aller disponibles. Chaque carte affiche la compagnie, l'itinéraire, les horaires et le prix par passager.",
                    "fltResDynOutboundActionTitle": "Sélectionner le vol aller", "fltResDynOutboundActionDesc": "Cliquez sur «Sélectionner» sur la carte de votre vol aller préféré pour le confirmer.",
                    "fltResDynReturnTitle": "Vols retour", "fltResDynReturnDesc": "Choisissez maintenant votre vol retour. Parcourez toutes les options disponibles pour votre voyage de retour.",
                    "fltResDynReturnActionTitle": "Sélectionner le vol retour", "fltResDynReturnActionDesc": "Cliquez sur «Sélectionner» pour confirmer votre vol retour.",
                    "fltResDynFinalTitle": "Vols sélectionnés", "fltResDynFinalDesc": "Les deux vols sont sélectionnés. Vérifiez le prix combiné avant de continuer.",
                    "fltResDynFinalActionTitle": "Passer à la commande", "fltResDynFinalActionDesc": "Cliquez sur «Passer à la commande» pour consulter les détails complets de la réservation.",
                    "fltViewAgentCommTitle": "Commission de l'agent",
                    "fltViewAgentCommDesc": "Consultez la commission d'agent suggérée pour ce vol avant de l'ajouter au panier.",
                    "fltViewCardTitle": "Détails du vol", "fltViewCardDesc": "Vérifiez les informations complètes du vol — compagnie, itinéraire, horaires, escales et options de bagages — avant de réserver.",
                    "fltViewPriceTitle": "Résumé du prix", "fltViewPriceDesc": "Le prix total est affiché par passager et en grand total. Les agents peuvent également définir leur commission avant d'ajouter au panier.",
                    "fltViewTcTitle": "Conditions générales", "fltViewTcDesc": "Consultez les règles tarifaires et la politique d'annulation — y compris les restrictions importantes — avant d'ajouter au panier.",
                    "fltViewActionTitle": "Ajouter au panier", "fltViewActionDesc": "Cliquez sur «Ajouter au panier» pour réserver ce vol. Le panier s'ouvrira pour que vous puissiez vérifier avant le paiement.",
                    "fltCartProductsTitle": "Votre panier", "fltCartProductsDesc": "Votre panier peut contenir plusieurs produits de tout type — vols, hôtels, forfaits et plus encore. Vous pouvez ajouter autant d'articles que nécessaire dans une seule commande. Vérifiez tout ce qui a été ajouté ici avant de continuer.",
                    "fltCartItemsTitle": "Articles du panier", "fltCartItemsDesc": "Chaque produit de votre panier est listé ici — détails du vol, type de chambre, dates et répartition des passagers. Vérifiez que tous les articles sont corrects avant de sauvegarder ou de continuer.",
                    "fltCartManageBaggageTitle": "Gérer les bagages", "fltCartManageBaggageDesc": "Cliquez sur ce bouton pour gérer les bagages de chaque passager — ajoutez des bagages supplémentaires ou ajustez les options pour les vols aller et retour séparément.",
                    "fltCartDiamondsTitle": "Solde de diamants", "fltCartDiamondsDesc": "Le nombre de diamants indique le cashback que vous obtiendrez pour cette réservation.",
                    "fltCartAgentTitle": "Options agent", "fltCartAgentDesc": "En tant qu'agent, vous avez un contrôle total sur votre commission pour cette commande. Définissez un pourcentage du total ou un montant fixe par personne — vous décidez combien vous gagnez sur chaque réservation.",
                    "fltCartAgentProfitBtnTitle": "Modifier le profit", "fltCartAgentProfitBtnDesc": "Cliquez sur ce bouton pour ouvrir les paramètres de profit et ajuster le calcul de commission.",
                    "fltCartAgentProfitInputsTitle": "Paramètres de profit", "fltCartAgentProfitInputsDesc": "Entrez un pourcentage du prix total ou un montant fixe par personne. Le système applique le mode actif.",
                    "fltCartAgentSendBtnTitle": "Envoyer une offre", "fltCartAgentSendBtnDesc": "Pour obtenir un lien d'offre en direct: associez d'abord un client à la commande, puis cliquez sur Sauvegarder l'offre — cela crée le lien. Une fois sauvegardé, cliquez ici pour ouvrir le panneau Envoyer une offre où vous pouvez copier le lien en direct, l'envoyer via WhatsApp ou le partager par email. Le lien en direct donne à votre client une vue en temps réel de la commande avec des prix toujours à jour.",
                    "fltCartAssignCustomerTitle": "Associez un client", "fltCartAssignCustomerDesc": "Cliquez sur le bouton Associer un client pour ouvrir le formulaire client et le lier à cette commande.",
                    "fltCartAssignModalTitle": "Remplissez les détails du client", "fltCartAssignModalDesc": "Remplissez les champs requis — nom, téléphone, email — et cliquez sur Sauvegarder le client pour l'associer à cette commande. La fenêtre se ferme automatiquement après la sauvegarde.",
                    "fltCartCustomerTitle": "Client lié", "fltCartCustomerDesc": "Le client associé est affiché ici. Avec un client lié, vous pouvez sauvegarder la commande et partager le lien de l'offre en direct — ou procéder au paiement en son nom.",
                    "fltCartCreateOrderTitle": "Sauvegarder et partager l'offre", "fltCartCreateOrderDesc": "Cliquez sur Sauvegarder l'offre quand vous êtes prêt — cette option n'est disponible qu'après avoir associé un client. La sauvegarde génère un lien d'offre en direct: quand votre client l'ouvre, les prix se mettent à jour automatiquement et la disponibilité est reflétée en temps réel. Vous pouvez également envoyer une offre sans le lien en direct si vous préférez.",
                    "fltCartComparePriceTitle": "Comparer les prix", "fltCartComparePriceDesc": "Cliquez pour comparer le prix de ce vol chez d'autres fournisseurs et trouver l'option la plus avantageuse.",
                    "fltCartTotalTitle": "Prix total", "fltCartTotalDesc": "Le prix total est affiché ici — incluant tous les produits et votre commission. Une fois satisfait, sauvegardez la commande en tant qu'offre à partager avec votre client, ou cliquez sur Procéder au paiement pour continuer vers la caisse.",
                    "fltCartActionTitle": "Procéder au paiement", "fltCartActionDesc": "Cliquez sur «Procéder au paiement» pour continuer la réservation et remplir les données des passagers.",
                    "fltCartSaveOfferActionTitle": "Sauvegardez l'offre pour terminer", "fltCartSaveOfferActionDesc": "Cliquez sur Sauvegarder l'offre pour générer le lien d'offre en direct et terminer cette étape. Vous pouvez partager le lien avec votre client à tout moment — les prix et la disponibilité restent à jour en temps réel.",
                    "fltCheckoutCartTitle": "Récapitulatif de commande", "fltCheckoutCartDesc": "Le panneau gauche affiche un récapitulatif du vol sélectionné et le montant total à payer.",
                    "fltCheckoutCustomerInfoTitle": "Informations client", "fltCheckoutCustomerInfoDesc": "Remplissez les informations personnelles du réservant dans cette section.",
                    "fltCheckoutFirstNameTitle": "Prénom", "fltCheckoutFirstNameDesc": "Entrez le prénom du réservant tel qu'il apparaît sur sa pièce d'identité ou son passeport.",
                    "fltCheckoutLastNameTitle": "Nom de famille", "fltCheckoutLastNameDesc": "Entrez le nom de famille du réservant tel qu'il apparaît sur sa pièce d'identité ou son passeport.",
                    "fltCheckoutPhoneTitle": "Numéro de téléphone", "fltCheckoutPhoneDesc": "Un numéro de téléphone valide est requis pour envoyer les détails de confirmation au réservant.",
                    "fltCheckoutEmailTitle": "Adresse e-mail", "fltCheckoutEmailDesc": "Entrez l'adresse e-mail du réservant pour recevoir la confirmation et les billets électroniques.",
                    "fltCheckoutGuestInfoTitle": "Données des passagers", "fltCheckoutGuestInfoDesc": "Remplissez le nom complet, le numéro de passeport et la date de naissance de chaque passager.",
                    "fltCheckoutTCTitle": "Conditions et accord", "fltCheckoutTCDesc": "Lisez et acceptez les conditions de réservation avant de soumettre votre commande.",
                    "fltCheckoutFormTitle": "Données des passagers", "fltCheckoutFormDesc": "Remplissez le nom complet, le numéro de passeport et la date de naissance de chaque passager.",
                    "fltCheckoutActionTitle": "Soumettre la commande", "fltCheckoutActionDesc": "Cliquez sur «Soumettre et passer au paiement» pour confirmer les données et passer à l'étape de paiement.",
                    "abBannerTitle": "Panneau de l'agent",
                    "abBannerDesc": "Cette bande en haut du B2C est votre panneau de contrôle exclusif en tant qu'agent. Elle vous donne un accès rapide à la gestion des clients, aux paramètres de tarification, au solde Diamonds et à votre compte.",
                    "abExchangeTitle": "Taux de change en direct",
                    "abExchangeDesc": "Les taux de change en temps réel sont affichés ici pour consultation rapide lors de réservations multi-devises.",
                    "abOnboardingBtnTitle": "Guide d'onboarding",
                    "abOnboardingBtnDesc": "Cliquez sur l'icône point d'interrogation à tout moment pour rouvrir le guide d'onboarding et revoir n'importe quelle étape.",
                    "abSwitchersTitle": "Commutateurs de mode de travail",
                    "abSwitchersDesc": "Deux bascules : mode Agent/Client — en mode Agent, les options de commission et les prix réservés aux agents sont visibles. Prix brut/net — basculez entre le prix de vente complet et le coût net.",
                    "abCustomerSearchTitle": "Recherche de client",
                    "abCustomerSearchDesc": "Recherchez un client existant par nom ou détails. Sélectionner un client le lie à la réservation en cours afin que la commande apparaisse dans son compte et puisse être gérée depuis le back-office.",
                    "abUpgradePlanTitle": "Passer au forfait supérieur",
                    "abUpgradePlanDesc": "Ce bouton apparaît quand votre agence est sur un forfait Light ou Regular. Cliquez pour ouvrir la boîte de dialogue de mise à niveau et débloquer les fonctionnalités avancées.",
                    "abDiamondsTitle": "Solde Diamonds",
                    "abDiamondsDesc": "Votre solde de cashback en Diamonds est affiché ici. Le total comprend les gains confirmés plus les récompenses futures en attente. Survolez l'icône pour voir le détail.",
                    "abUserMenuTitle": "Votre compte",
                    "abUserMenuDesc": "Cliquez sur votre nom pour ouvrir le menu du compte — voir votre profil, le statut du forfait de l'agence et vous déconnecter. Cliquez sur Terminer pour compléter cette étape.",
                    "pkgResSearchActionTitle": "Rechercher un forfait",
                    "pkgResSearchActionDesc": "Remplissez vos détails de voyage ci-dessus et cliquez sur Rechercher pour voir les forfaits disponibles.",
                    "pkgResOverviewTitle": "Résultats de recherche",
                    "pkgResOverviewDesc": "Vous pouvez voir ici tous les forfaits disponibles correspondant à votre recherche. Chaque carte affiche l'hôtel, les dates, le prix et les vols inclus.",
                    "pkgResSideFiltersTitle": "Filtrer les résultats",
                    "pkgResSideFiltersDesc": "Utilisez les filtres latéraux pour affiner les résultats par prix, destination, étoiles de l'hôtel et plus encore.",
                    "pkgResCardTitle": "Carte de forfait",
                    "pkgResCardDesc": "Chaque carte affiche le nom de l'hôtel, les dates de voyage, les vols, les extras inclus et le prix par personne. Cliquez sur « Commander » pour ouvrir les détails complets.",
                    "pkgResActionTitle": "Ouvrir les détails du forfait",
                    "pkgResActionDesc": "Cliquez sur « Commander » sur n'importe quelle carte de forfait pour ouvrir les détails complets dans un nouvel onglet et choisir votre chambre.",
                    "pkgPageHotelTitle": "Informations sur l'hôtel",
                    "pkgPageHotelDesc": "Cette section présente tout sur l'hôtel de ce forfait — photos, nom, classement en étoiles et dates de réservation.",
                    "pkgPageGalleryTitle": "Photos de l'hôtel",
                    "pkgPageGalleryDesc": "Parcourez la galerie de l'hôtel — cliquez sur n'importe quelle photo pour ouvrir la visionneuse plein écran et explorer toutes les images.",
                    "pkgPageDetailsTitle": "Nom et classement de l'hôtel",
                    "pkgPageDetailsDesc": "Vous pouvez voir ici le nom de l'hôtel, la destination, le classement en étoiles, les dates de voyage et la durée totale du séjour.",
                    "pkgPageIncludesTitle": "Ce qui est inclus",
                    "pkgPageIncludesDesc": "Cette zone liste tout ce qui est compris dans le prix du forfait — vols, transferts, activités et billets d'événements.",
                    "pkgPageFlightsTitle": "Détails du vol",
                    "pkgPageFlightsDesc": "Cette section présente les vols aller et retour inclus dans le forfait — compagnie aérienne, horaires et itinéraire.",
                    "pkgPageRoomsTitle": "Choisir votre chambre",
                    "pkgPageRoomsDesc": "Voici tous les types de chambres disponibles pour ce forfait. Comparez les options par prix, formule de pension et caractéristiques.",
                    "pkgPageRoomFiltersTitle": "Filtres des chambres",
                    "pkgPageRoomFiltersDesc": "Utilisez ces filtres pour affiner les options par nombre de personnes, formule de pension (petit-déjeuner, demi-pension, tout compris) ou nom de chambre.",
                    "pkgPageRoomCardTitle": "Fiche de chambre",
                    "pkgPageRoomCardDesc": "Chaque fiche affiche une photo, le nom de la chambre et les équipements disponibles. Faites défiler vers le bas pour voir toutes les lignes tarifaires.",
                    "pkgPageRoomPriceTitle": "Prix et type de pension",
                    "pkgPageRoomPriceDesc": "Chaque ligne indique la formule de pension, la politique d'annulation, les inclusions et le prix total. Choisissez l'option adaptée à votre client.",
                    "pkgPageAddToCartTitle": "Ajouter la chambre au panier",
                    "pkgPageAddToCartDesc": "Cliquez sur « Ajouter à la commande » sur la chambre choisie pour ajouter ce forfait au panier et passer au paiement.",
                    "moOrderIdTitle": "Référence de commande",
                    "moOrderIdDesc": "Votre numéro de commande est affiché ici. Utilisez-le pour référencer rapidement cette réservation lorsque vous contactez l'assistance ou suivez la réservation.",
                    "moCartOverviewTitle": "Récapitulatif de réservation",
                    "moCartOverviewDesc": "Le panneau gauche affiche le récapitulatif complet de votre réservation — tous les produits réservés, la ventilation des prix et les actions disponibles.",
                    "moCartProductsTitle": "Produits réservés",
                    "moCartProductsDesc": "Chaque article de votre commande est répertorié ici — détails du vol, type de chambre, dates et nombre de passagers. Vérifiez tous les produits avant d'effectuer des modifications.",
                    "moCartAgentTitle": "Options agent",
                    "moCartAgentDesc": "En tant qu'agent, vous pouvez ajuster votre commission sur cette commande — définissez un pourcentage ou un montant fixe par personne. Les modifications mettent à jour le prix total affiché au client.",
                    "moCartTotalTitle": "Total de la commande",
                    "moCartTotalDesc": "Le montant total à payer est affiché en bas du panier. Vérifiez-le attentivement — il reflète tous les produits plus toute commission d'agent appliquée.",
                    "moTitleAreaTitle": "Actions de la page",
                    "moTitleAreaDesc": "La partie supérieure du formulaire affiche le titre de la page. Le bouton « Passer au paiement » vous permet de passer à l'étape de paiement après avoir vérifié et mis à jour les détails de la commande.",
                    "moPaymentBtnTitle": "Passer au paiement",
                    "moPaymentBtnDesc": "Cliquez sur ce bouton lorsque les détails de la commande sont complets et corrects. Vous serez dirigé vers la section de paiement où vous pourrez choisir un mode de paiement et finaliser la réservation.",
                    "moFormTitle": "Formulaire de détails de commande",
                    "moFormDesc": "Ce formulaire vous permet de consulter et mettre à jour tous les détails de la commande — informations client, noms des invités, détails du passeport et demandes spéciales. Remplissez tous les champs obligatoires avant de passer au paiement."
                },
                "guideExplorer": {
                    "title": "Explorateur de guides",
                    "subtitle": "Explorez les fonctionnalités à votre rythme",
                    "startBtn": "Démarrer",
                    "doneLabel": "Terminé",
                    "noSiteTooltip": "Nécessite un site configuré",
                    "timesCompleted": "fois complétées",
                    "filtersTitle": "Filtres"
                },
            },
            "bot": {
                "title": "Assistant voyage Sky360",
                "newChat": "Nouvelle conversation",
                "previewCart": "Aperçu du panier",
                "addingToCart": "Ajout au panier…",
                "blocked": "Ce chat a été désactivé.",
                "reconnecting": "Reconnexion…",
                "connectionError": "Erreur de connexion — nouvelle tentative…",
                "emptyState": {
                    "title": "Comment puis-je vous aider à planifier votre voyage ?",
                    "subtitle": "Demandez-moi des vols, hôtels, forfaits ou activités."
                },
                "input": {
                    "placeholder": "Posez-moi vos questions sur votre voyage…",
                    "disabled": "Chat désactivé"
                },
                "itinerary": {
                    "titleOne": "1 élément · {{total}}",
                    "titleOther": "{{count}} éléments · {{total}}",
                    "total": "Total",
                    "remove": "Supprimer"
                },
                "checkout": {
                    "title": "Votre itinéraire",
                    "travellers": "Voyageurs",
                    "total": "Total",
                    "confirmBook": "Confirmer et réserver",
                    "completeBooking": "Finaliser la réservation"
                },
                "result": {
                    "select": "Sélectionner",
                    "direct": "Direct",
                    "stopsOne": "1 escale",
                    "stopsOther": "{{count}} escales",
                    "freeCancellation": "Annulation gratuite",
                    "return": "Retour",
                    "nights": "nuits",
                    "perNight": "/nuit"
                }
            },
            "changeApproval": {
                "greeting": "Bonjour",
                "subtitle": "Votre vol a été modifié",
                "changeTableTitle": "Détails du changement",
                "colField": "Champ",
                "colBefore": "Avant",
                "colAfter": "Après",
                "confirmPrompt": "Veuillez confirmer que vous êtes au courant de ce changement dans votre réservation.",
                "confirmBtn": "Confirmer le changement",
                "declineBtn": "Je refuse",
                "expiresLabel": "Expire le",
                "expiresIn": "Le lien expire dans",
                "confirmedTitle": "Changement confirmé",
                "confirmedMsg": "Vous avez confirmé ce changement le",
                "declinedTitle": "Changement refusé",
                "declinedMsg": "Vous avez refusé ce changement. Notre équipe vous contactera.",
                "expiredTitle": "Lien expiré",
                "expiredMsg": "Ce lien a expiré. Veuillez contacter le support.",
                "failedTitle": "Lien non disponible",
                "failedMsg": "Ce lien n'est pas disponible. Veuillez contacter le support.",
                "errorBanner": "Une erreur s'est produite. Veuillez réessayer.",
                "loading": "Chargement...",
                "orderLabel": "Commande",
                "days": "jours",
                "hours": "heures",
                "minutes": "minutes"
            }
        }
    }
};

export default translationsEn;